(function () {
  'use strict';

  function tqRunInit() {
  var TRADE_MAIL_IN_SUPPORT_CONTACT =
    typeof window.__TQ_MAIL_SUPPORT__ === 'string' ? window.__TQ_MAIL_SUPPORT__ : '';
  var TRADE_MAIL_IN_CONSUMER_FALLBACK =
    'Oops! Our server hit a snag processing your trade. Please try again or contact support at ' +
    (TRADE_MAIL_IN_SUPPORT_CONTACT || '[Insert Store Phone/Email]') +
    '.';

  const TRADE_CALC_API_URL = "/apps/trade/api/trade-calculator/scan";
  const TRADE_CALC_SEARCH_URL = "/apps/trade/api/trade-calculator/search";
  const TRADE_CALC_RESOLVE_URL = "/apps/trade/api/trade-calculator/resolve-lines";
  const TRADE_MAIL_IN_URL = "/apps/trade/api/trade-calculator/mail-in";
  const TRADE_IN_STORE_QUOTE_URL = "/apps/trade/api/trade-calculator/in-store-quote";
  const MAIL_FREE_SHIPPING_MIN = 100;
  const MAIL_SHIPPING_FEE = 7.99;
  const MAIL_IN_CONTIGUOUS_US_MSG =
    'We currently only accept mail-in trades from the contiguous 48 United States.';
  var MAIL_IN_BLOCKED_STATES = {
    AK: true,
    HI: true,
    PR: true,
    GU: true,
    VI: true,
    AS: true,
    MP: true,
    AA: true,
    AE: true,
    AP: true,
  };

  /** Trim, collapse whitespace, and fold Latin diacritics so "Pokémon" matches catalog / API tokenization. */
  function normalizeSearchQueryForApi(raw) {
    var s = (raw || '').trim();
    if (!s) return '';
    s = s.split(/\s+/).join(' ').trim();
    try {
      if (String.prototype.normalize) {
        s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      }
    } catch (e) {}
    return s;
  }

  const GENERIC_CART_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 90' width='60' height='90'%3E%3Crect width='60' height='90' fill='%23e0e0e0'/%3E%3Cpath fill='%23ccc' d='M10 10h40v30H10z'/%3E%3C/svg%3E";

  const TQ_CART_STORAGE_KEY = 'ri_tq_cart_v1';
  /** Persists `ISQ-…` id for server-side quote funnel (upsert + mail-in link). */
  const TQ_QUOTE_ID_STORAGE_KEY = 'ri_tq_quote_id_v1';

  const root = document.getElementById('tqRoot');
  if (!root) {
    console.error('[tq] #tqRoot not found — trade calculator section may be missing or script ran before its HTML.');
    return;
  }

  const els = {
    flyLayer: document.getElementById('tqFlyLayer'),
    toast: document.getElementById('tqToast'),
    loader: document.getElementById('tqLoader'),
    cameraHost: document.getElementById('tqCameraHost'),
    sheet: document.getElementById('tqSheet'),
    sheetGrabber: document.getElementById('tqSheetGrabber'),
    sheetPeek: document.getElementById('tqSheetPeek'),
    sheetBody: document.getElementById('tqSheetBody'),
    search: document.getElementById('tqSearch'),
    searchDd: document.getElementById('tqSearchDropdown'),
    sysFilter: document.getElementById('tqSysFilter'),
    sheetList: document.getElementById('tqSheetList'),
    sheetListWrap: document.getElementById('tqSheetListWrap'),
    peekCredit: document.getElementById('tqPeekCredit'),
    peekCash: document.getElementById('tqPeekCash'),
    checkout: document.getElementById('tqCheckout'),
    checkoutBody: document.getElementById('tqCheckoutBody'),
    checkoutTitle: document.getElementById('tqCheckoutTitle'),
    fail: document.getElementById('tqFail'),
    failMsg: document.getElementById('tqFailMsg'),
  };

  let manualSearchTimeout = null;
  let manualSearchLastResults = [];
  let catchSearchTimeout = null;
  let catchTitleSearchResults = [];
  let liveVideoStream = null;
  let scanPauseUntil = 0;
  let captureScanInFlight = false;
  let scanCanvas = null;
  let catchModalOpen = false;
  /** Games waiting for confirm (same order as scan). Current index: catchReviewIndex. */
  let catchReviewList = [];
  /** Original scan batch size; pager shows position within this total (stable as items are removed). */
  let catchBatchTotal = 0;
  let catchReviewIndex = 0;
  let catchDraft = null;
  /** True while mousedown on catch title search result (avoids blur committing typed query before click). */
  let catchTitleBlurFromPick = false;
  let sheetResizeLocked = false;
  /** In-flight in-store quote POST; stale responses ignored when this changes. */
  var inStoreQuoteFetchGen = 0;
  var storefrontQuoteSyncTimer = null;
  var storefrontQuoteSyncGen = 0;
  var tqWasShowingLocalCheckout = false;
  /** While editing catch title: sheet stays peek + sheet focusin won't force full. */
  let catchTitleEditPrevSnap = null;
  /** Saved window scroll while catch confirm is open (iOS / theme page scroll-through). */
  let catchBodyScrollLockY = 0;
  var tqCheckoutScrollLockHeld = false;
  let displayedTotals = { credit: 0, cash: 0 };
  let totalAnimFrame = null;

  const _s = {
    cart: [],
    view: 'hero',
    tradeType: null,
    checkoutStep: null,
    systemFilter: 'ALL',
    sheetSnap: 'peek',
    lastToast: '',
    defaultCond: 'loose',
    conditionGateDone: true,
    mailFlowStep: 'quality',
    mailSubmitResult: null,
    mailSubmitPending: false,
    mailAddressSnapshot: null,
    mailPaymentMethod: 'paypal',
    mailPaymentDetail: '',
    mailQualityAcknowledged: false,
    inStoreQrSig: '',
    inStoreQrPayload: '',
    inStoreQrPending: false,
    inStoreQrPendingForSig: '',
    inStoreQrError: '',
    inStoreQrFailedSig: '',
    /** Canonical `ISQ-…` from server; kept in localStorage with the cart. */
    storefrontQuoteId: '',
  };

  const listeners = new Set();
  function subscribe(fn) { listeners.add(fn); return function () { listeners.delete(fn); }; }
  function notify() { listeners.forEach(function (fn) { try { fn(); } catch (e) { console.error(e); } }); }

  const state = new Proxy(_s, {
    set: function (target, prop, value) {
      if (prop === 'sheetSnap' && value === 'mid') value = 'full';
      if (target[prop] === value) return true;
      target[prop] = value;
      notify();
      return true;
    },
  });

  function setState(patch) {
    if (patch && patch.sheetSnap === 'mid') patch.sheetSnap = 'full';
    Object.assign(_s, patch);
    notify();
  }

  function withViewTransition(run) {
    if (document.startViewTransition) document.startViewTransition(run);
    else run();
  }

  function haptic() {
    try {
      if (navigator.vibrate) navigator.vibrate(42);
    } catch (e) {}
  }

  function hapticLight() {
    try {
      if (navigator.vibrate) navigator.vibrate(10);
    } catch (e) {}
  }

  /** Default toast visibility; optional second arg uses longer duration for errors users need to read. */
  var TQ_TOAST_MS = 4500;
  var TQ_TOAST_ERROR_MS = 14000;

  function showToast(msg, durationMs) {
    if (!els.toast || !msg) return;
    var ms = typeof durationMs === 'number' && durationMs > 0 ? durationMs : TQ_TOAST_MS;
    els.toast.textContent = msg;
    els.toast.hidden = false;
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () { els.toast.hidden = true; }, ms);
  }

  function formatMoneyPlain(n) {
    return '$' + n.toFixed(2);
  }

  /**
   * Per-line cash/credit rules are duplicated from src/lib/tradeCalculator/storefrontLineOffer.ts
   * (admin Trade Calculator + mail-in snapshot). Keep in sync when changing Loose caps.
   * Quote-time TLC is retired; $0.95 is baked into stored catalog offers.
   */

  function roundMoneyLineOffer2(n) {
    return Math.round(Math.max(0, n) * 100) / 100;
  }

  function linePrices(item) {
    var sel = item.selected || 'loose';
    var o = item.offers && item.offers[sel];
    if (!o && item.offers && item.offers.loose) o = item.offers.loose;
    if (!o) o = { credit: 0, cash: 0 };
    var bonus = 0;
    var fc = Number(o.credit) + bonus;
    var fk = Number(o.cash) + bonus;
    if (isNaN(fc)) fc = 0;
    if (isNaN(fk)) fk = 0;
    /* Display-only: loose should not read higher than in-box tier; QR / stored offers unchanged. */
    if (sel === 'loose' && item.offers) {
      var boxKey = isModernCatalogYear(releaseYearFromItem(item)) ? 'cib' : 'inbox';
      var boxO = item.offers[boxKey];
      if (boxO) {
        var boxK = Number(boxO.cash) + bonus;
        var boxC = Number(boxO.credit) + bonus;
        if (!isNaN(boxK) && fk > boxK) fk = Math.max(0, boxK - 0.01);
        if (!isNaN(boxC) && fc > boxC) fc = Math.max(0, boxC - 0.01);
      }
    }
    return { credit: roundMoneyLineOffer2(fc), cash: roundMoneyLineOffer2(fk) };
  }

  function releaseYearFromItem(item) {
    if (!item || item.releaseYear == null || item.releaseYear === '') return null;
    var y = Number(item.releaseYear);
    if (isNaN(y) || y < 1900 || y > 2100) return null;
    return y;
  }

  function isModernCatalogYear(year) {
    return year != null && year > 2011;
  }

  var MIN_TRADE_GAME_SCORE = 85;
  /** Low sales volume + high CIB market → in-person cash only (no online quote). */
  var IN_PERSON_MIN_SALES_VOLUME = 10;
  var IN_PERSON_MIN_MARKET_CIB = 500;

  function itemIsHotlist(item) {
    return !!(item && item.isHotlist);
  }

  function isLowTradeGameScore(item) {
    if (!item || item.gameScore == null || item.gameScore === '') return false;
    var g = Number(item.gameScore);
    if (isNaN(g)) return false;
    return g < MIN_TRADE_GAME_SCORE;
  }

  /** From scan API when platform/region/genre/title fails NA storefront rules (same filter as manual search). */
  function isStorefrontTradeCatalogBlocked(item) {
    return !!(item && item.tradeStorefrontBlocked === true);
  }

  function isStorefrontTradeScoreOrCatalogBlocked(item) {
    return isLowTradeGameScore(item) || isStorefrontTradeCatalogBlocked(item);
  }

  /** True when every priced tier on this item is $0 — no usable offer data. */
  function tradeOffersAllZero(item) {
    if (!item) return true;
    var off = item.offers;
    if (!off || typeof off !== 'object') return true;
    var year = releaseYearFromItem(item);
    var modern = isModernCatalogYear(year);
    var keys = ['loose', 'cib'];
    if (!modern) keys.splice(1, 0, 'inbox');
    var i;
    for (i = 0; i < keys.length; i++) {
      var o = off[keys[i]];
      if (!o) continue;
      var c = Number(o.cash);
      var r = Number(o.credit);
      if ((!isNaN(c) && c > 0) || (!isNaN(r) && r > 0)) return false;
    }
    return true;
  }

  function tradeTierKeysForItem(item) {
    var year = releaseYearFromItem(item);
    var modern = isModernCatalogYear(year);
    var keys = ['loose', 'cib'];
    if (!modern) keys.splice(1, 0, 'inbox');
    return keys;
  }

  /** True when catalog sales volume is low and CIB market value is high — staff must evaluate in store. */
  function isLowVolumeHighValueCib(item) {
    if (!item) return false;
    if (item.salesVolume == null || item.salesVolume === '') return false;
    var vol = Number(item.salesVolume);
    if (isNaN(vol) || vol >= IN_PERSON_MIN_SALES_VOLUME) return false;
    if (item.marketCib == null || item.marketCib === '') return false;
    var cib = Number(item.marketCib);
    return !isNaN(cib) && cib > IN_PERSON_MIN_MARKET_CIB;
  }

  /** True if any modeled tier present on the item lists $0.00 cash (strict in-person / no online offer). */
  function anyTradeTierHasZeroCash(item) {
    if (!item || !item.offers) return false;
    var keys = tradeTierKeysForItem(item);
    var i;
    for (i = 0; i < keys.length; i++) {
      var o = item.offers[keys[i]];
      if (!o) continue;
      var c = Number(o.cash);
      if (!isNaN(c) && c === 0) return true;
    }
    return false;
  }

  function needsInPersonCashOffer(item) {
    if (!item || isStorefrontTradeScoreOrCatalogBlocked(item)) return false;
    if (isLowVolumeHighValueCib(item)) return true;
    if (tradeOffersAllZero(item)) return false;
    return anyTradeTierHasZeroCash(item);
  }

  /**
   * Packaging heuristics (cardboard box vs plastic keep-case vs disc).
   * Dashboard SoT: src/lib/tradeCalculator/platformPackaging.ts — keep lists/heuristics in sync.
   */
  /** Collapse odd spaces (NBSP, double space) so PriceCharting / DB strings still match. */
  function normalizeTradePlatformName(system) {
    return String(system || '')
      .toLowerCase()
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /**
   * Exact GlobalCatalog / PriceCharting platformName values we always treat as plastic game cases.
   * (Inbox/CIB labels use "Case", not "Box".)
   */
  var PLASTIC_CASE_PLATFORM_EXACT = {
    'nintendo 3ds': true,
    'nintendo 2ds': true,
    'nintendo ds': true,
    'nintendo dsi': true,
    'nintendo switch': true,
    'nintendo switch 2': true,
    'playstation vita': true,
  };

  /**
   * DS / 3DS / 2DS / Switch / Vita family: plastic keep case, not a cardboard "box".
   * Uses exact catalog names plus word-boundary heuristics for variants (XL, New, etc.).
   */
  function isPlasticCaseCartridgePlatform(system) {
    var key = normalizeTradePlatformName(system);
    if (!key) return false;
    if (PLASTIC_CASE_PLATFORM_EXACT[key]) return true;
    var s = key;
    function has(sub) {
      return s.indexOf(sub) !== -1;
    }
    if (has('playstation vita') || has('ps vita') || has('psvita')) return true;
    if (/\b3ds\b/.test(s) || /\b2ds\b/.test(s)) return true;
    if (has('nintendo 3ds') || has('new 3ds') || has('new nintendo 3ds')) return true;
    if (has('nintendo ds') || has('nintendo dsi')) return true;
    if (has('nintendo switch') || has('switch 2') || has('switch lite')) return true;
    if (has('nintendo') && /\bswitch\b/.test(s)) return true;
    return false;
  }

  /**
   * Cartridge-family platforms that use game cases (not cardboard boxes) for the inbox/CIB tier copy only.
   */
  function usesCaseForCartridgeInbox(system) {
    return isPlasticCaseCartridgePlatform(system);
  }

  /**
   * Loose tier label from GlobalCatalog-style platformName (heuristic).
   * Disc: optical/UMD platforms. Cartridge: carts, Switch family, Vita cards, etc.
   * Tweak keyword lists if your platform strings differ.
   */
  function getLooseConditionLabel(system) {
    var s = normalizeTradePlatformName(system);
    function has(sub) {
      return s.indexOf(sub) !== -1;
    }
    /* Vita before discKw: substring "playstation" would otherwise match "PlayStation Vita". */
    if (has('playstation vita') || has('ps vita') || has('psvita')) return 'Cartridge Only';
    var discKw = [
      'wii u', 'gamecube', 'game cube', 'playstation 5', 'playstation 4', 'playstation 3', 'playstation 2', 'playstation',
      'psp', 'umd', 'xbox', 'dreamcast', 'sega cd', 'mega cd', 'segacd', 'sega saturn', 'neo geo cd', 'neogeocd',
      '3do', 'cd-i', 'turbografx-cd', 'pc-engine cd', 'pc engine cd', 'philips cd-i',
    ];
    var i;
    for (i = 0; i < discKw.length; i++) {
      if (has(discKw[i])) return 'Disc Only';
    }
    if (has('wii') && !has('wii u')) return 'Disc Only';
    if (/\bps\s*5\b/.test(s) || /\bps\s*4\b/.test(s) || /\bps\s*3\b/.test(s) || /\bps\s*2\b/.test(s) || /\bps\s*1\b/.test(s)) {
      return 'Disc Only';
    }
    if (isPlasticCaseCartridgePlatform(system)) return 'Cartridge Only';
    var cartKw = [
      'nintendo switch', 'switch 2', 'switch lite', 'new 3ds', 'nintendo 3ds', 'nintendo ds', 'nintendo dsi', '2ds',
      'game boy', 'gameboy', 'virtual boy', 'nintendo entertainment system', 'nes', 'famicom', 'snes', 'super nintendo', 'nintendo 64', 'n64',
      'game gear', 'genesis', 'mega drive', 'master system', '32x', 'neo geo', 'neo-geo', 'aes',
      'turbografx-16', 'turbografx', 'pc engine', 'tg-16', 'atari', 'lynx', 'jaguar',
      'intellivision', 'colecovision', 'wonderswan',
    ];
    for (i = 0; i < cartKw.length; i++) {
      if (has(cartKw[i])) return 'Cartridge Only';
    }
    return 'Game Only';
  }

  function isCartridgeSystem(system) {
    return getLooseConditionLabel(system) === 'Cartridge Only';
  }

  /** Cardboard boxed carts default Loose; plastic keep-case + disc default CIB. */
  function defaultConditionForSystem(system) {
    if (isCartridgeSystem(system) && !isPlasticCaseCartridgePlatform(system)) return 'loose';
    return 'cib';
  }

  /**
   * Completeness icons: Lucide-style disc (two circles, scaled down); Tabler rectangle-vertical outline + filled
   * (MIT, https://tabler.io/icons). In-box outline uses an opaque blockout (var --tq-case-blockout) so the disc
   * does not read through the case interior. Cartridge: Noun #8079932 — honor Noun license. Cart inbox/CIB use the
   * optical vs cart: caseShiftOptical / caseShiftCartridge + discShiftOptical / discShiftCartridge. Loose cart scaled up.
   */
  function getConditionIcons(isCartridge) {
    var svgOpen =
      '<svg xmlns="http://www.w3.org/2000/svg" class="tq-catch-cond-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" overflow="visible" aria-hidden="true">';
    var svgClose = '</svg>';
    function iconFit(inner) {
      return '<g transform="translate(12,12) scale(0.88) translate(-12,-12)">' + inner + '</g>';
    }
    function iconFitDiscLoose(inner) {
      return '<g transform="translate(12,12) scale(0.96) translate(-12,-12)">' + inner + '</g>';
    }
    var lucideDiscSmall =
      '<circle cx="12" cy="12" r="7" fill="none" stroke="currentColor"/>' +
      '<circle cx="12" cy="12" r="1.5" fill="none" stroke="currentColor"/>';
    var lucideDiscLoose =
      '<circle cx="12" cy="12" r="9" fill="none" stroke="currentColor"/>' +
      '<circle cx="12" cy="12" r="2" fill="none" stroke="currentColor"/>';
    var tablerCaseOutline =
      '<path fill="none" stroke="currentColor" d="M5 5a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2l0 -14"/>';
    var tablerCaseFilled =
      '<path fill="currentColor" stroke="none" d="M17 2h-10a3 3 0 0 0 -3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3 -3v-14a3 3 0 0 0 -3 -3z"/>';
    var tablerCaseBlockout =
      '<path fill="var(--tq-case-blockout, #e0e0e0)" stroke="none" d="M17 2h-10a3 3 0 0 0 -3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3 -3v-14a3 3 0 0 0 -3 -3z"/>';
    var discShiftOptical = 6.4;
    var discShiftCartridge = 4.95;
    var cartPeekTy = -0.4;
    var caseShiftOptical = -2.55;
    var caseShiftCartridge = -1.55;
    var discShiftedOptical = '<g transform="translate(' + discShiftOptical + ',0)">' + lucideDiscSmall + '</g>';
    var caseStackInboxOptical =
      '<g transform="translate(' + caseShiftOptical + ',0)">' + tablerCaseBlockout + tablerCaseOutline + '</g>';
    var caseStackCibOptical =
      '<g transform="translate(' + caseShiftOptical + ',0)">' + tablerCaseFilled + '</g>';
    var caseStackInboxCart =
      '<g transform="translate(' + caseShiftCartridge + ',0)">' + tablerCaseBlockout + tablerCaseOutline + '</g>';
    var caseStackCibCart =
      '<g transform="translate(' + caseShiftCartridge + ',0)">' + tablerCaseFilled + '</g>';
    var discLoose = svgOpen + iconFitDiscLoose(lucideDiscLoose) + svgClose;
    var discInbox = svgOpen + iconFit(discShiftedOptical + caseStackInboxOptical) + svgClose;
    var discCib = svgOpen + iconFit(discShiftedOptical + caseStackCibOptical) + svgClose;
    function nounCartAtScale(s) {
      return (
        '<g fill="currentColor" stroke="none" transform="translate(12,12.25) scale(' +
        s +
        ') translate(-600,-518)">' +
        '<path d="m888 24h-576c-99.375 0.09375-179.9 80.625-180 180v792c0.09375 99.375 80.625 179.9 180 180h576c99.375-0.09375 179.9-80.625 180-180v-792c-0.09375-99.375-80.625-179.9-180-180zm108 972c-0.09375 59.625-48.375 107.91-108 108h-576c-59.625-0.09375-107.91-48.375-108-108v-792c0.09375-59.625 48.375-107.91 108-108h576c59.625 0.09375 107.91 48.375 108 108zm-108-828h-576c-19.875 0-36 16.125-36 36v504c0 19.875 16.125 36 36 36h576c19.875 0 36-16.125 36-36v-504c0-19.875-16.125-36-36-36zm-36 504h-504v-252h504zm-108 144h-288c-19.875 0-36 16.125-36 36 0 9.5625 3.7969 18.703 10.547 25.453l144 144c14.062 14.062 36.844 14.062 50.906 0l144-144c14.062-14.062 14.062-36.844 0-50.906-6.75-6.75-15.891-10.547-25.453-10.547z"/>' +
        '</g>'
      );
    }
    var nounCartPeek = nounCartAtScale(0.0124);
    var nounCartLoose = nounCartAtScale(0.0165);
    var cartShifted =
      '<g transform="translate(' + discShiftCartridge + ',' + cartPeekTy + ')">' + nounCartPeek + '</g>';
    var cartLoose = svgOpen + iconFit(nounCartLoose) + svgClose;
    var cartInbox = svgOpen + iconFit(cartShifted + caseStackInboxCart) + svgClose;
    var cartCib = svgOpen + iconFit(cartShifted + caseStackCibCart) + svgClose;
    if (isCartridge) {
      return { loose: cartLoose, inbox: cartInbox, cib: cartCib };
    }
    return { loose: discLoose, inbox: discInbox, cib: discCib };
  }

 /**
 * In-box / CIB tier copy: Dynamic based on platform packaging.
 * Retro carts use "Box". Discs and modern plastic carts (DS/Switch) use "Case".
 */
function getInboxTierLabel(system) {
  if (isCartridgeSystem(system) && !isPlasticCaseCartridgePlatform(system)) {
    return 'Has Box';
  }
  return 'Has Case';
}

function getCibTierLabel(system) {
  if (isCartridgeSystem(system) && !isPlasticCaseCartridgePlatform(system)) {
    return 'Has Box & Manual';
  }
  return 'Has Case & Manual';
}

  function syncCatchConditionSegmentUI(draft) {
    if (!draft) return;
    var seg = document.getElementById('tqCatchSeg');
    if (!seg) return;
    var year = releaseYearFromItem(draft);
    var modern = isModernCatalogYear(year);
    var looseBtn = document.getElementById('tqCatchSegLoose');
    var inboxBtn = document.getElementById('tqCatchSegInbox');
    var cibBtn = document.getElementById('tqCatchSegCib');
    function setCatchCardLabel(btn, text) {
      if (!btn) return;
      var lab = btn.querySelector('.tq-catch-cond-label');
      if (lab) lab.textContent = text;
    }
    setCatchCardLabel(looseBtn, getLooseConditionLabel(draft.system));
    seg.classList.toggle('tq-catch-seg--modern', modern);
    seg.classList.toggle('tq-catch-seg--cartridge', isCartridgeSystem(draft.system));
    if (inboxBtn) {
      inboxBtn.hidden = false;
      inboxBtn.removeAttribute('aria-hidden');
      setCatchCardLabel(inboxBtn, getInboxTierLabel(draft.system));
    }
    if (cibBtn) {
      cibBtn.hidden = modern;
      cibBtn.setAttribute('aria-hidden', modern ? 'true' : 'false');
      if (!modern) setCatchCardLabel(cibBtn, getCibTierLabel(draft.system));
    }
    if (modern && draft.selected === 'inbox') {
      draft.selected = 'cib';
      if (catchReviewList.length && catchReviewIndex >= 0 && catchReviewIndex < catchReviewList.length) {
        catchReviewList[catchReviewIndex] = Object.assign({}, draft);
      }
    }
    var icons = getConditionIcons(isCartridgeSystem(draft.system));
    function setCatchCardIcon(btn, html) {
      if (!btn) return;
      var wrap = btn.querySelector('.tq-catch-cond-icon-wrap');
      if (wrap) wrap.innerHTML = html;
    }
    setCatchCardIcon(looseBtn, icons.loose);
    setCatchCardIcon(inboxBtn, icons.inbox);
    setCatchCardIcon(cibBtn, icons.cib);
    seg.querySelectorAll('[data-catch-cond]').forEach(function (b) {
      var k = b.getAttribute('data-catch-cond');
      if (modern && k === 'cib') return;
      var on = draft.selected === k;
      if (modern && k === 'inbox' && draft.selected === 'cib') on = true;
      b.classList.toggle('is-selected', on);
    });
  }

  function cartTotals() {
    var tc = 0, tk = 0;
    state.cart.forEach(function (item) {
      if (isStorefrontTradeScoreOrCatalogBlocked(item)) return;
      if (needsInPersonCashOffer(item)) return;
      var p = linePrices(item);
      tc += p.credit;
      tk += p.cash;
    });
    return { credit: tc, cash: tk };
  }

  function animateTotalsTo(targetCredit, targetCash) {
    var fromC = displayedTotals.credit;
    var fromK = displayedTotals.cash;
    if (totalAnimFrame) cancelAnimationFrame(totalAnimFrame);
    var start = performance.now();
    var dur = 420;
    function tick(now) {
      var t = Math.min(1, (now - start) / dur);
      var e = 1 - Math.pow(1 - t, 3);
      displayedTotals.credit = fromC + (targetCredit - fromC) * e;
      displayedTotals.cash = fromK + (targetCash - fromK) * e;
      if (els.peekCredit) els.peekCredit.textContent = formatMoneyPlain(displayedTotals.credit);
      if (els.peekCash) els.peekCash.textContent = formatMoneyPlain(displayedTotals.cash);
      if (t < 1) totalAnimFrame = requestAnimationFrame(tick);
      else totalAnimFrame = null;
    }
    totalAnimFrame = requestAnimationFrame(tick);
  }

  function getSystemStyle(sysName) {
    var sys = (sysName || '').toLowerCase();
    if (sys.includes('64')) return 'background:#FFC300;color:#000;';
    if (sys.includes('color') || sys.includes('gbc')) return 'background:#800000;color:#fff;';
    if (sys.includes('ds') && !sys.includes('3ds')) return 'background:#222;color:#fff;border:1px solid #444;';
    if (sys.includes('gamecube') || sys.includes('advance') || sys.includes('gba')) return 'background:#382E87;color:#fff;';
    if (sys.includes('wii') && !sys.includes('u')) return 'background:#7D7D7D;color:#fff;';
    if (sys.includes('ps5') || sys.includes('playstation 5')) return 'background:#000;color:#fff;border:1px solid #333;';
    if (sys.includes('ps3') || sys.includes('playstation 3')) return 'background:#1F1F1F;color:#fff;';
    if (sys.includes('ps2') || sys.includes('playstation 2')) return 'background:#001E63;color:#fff;';
    if (sys === 'playstation' || sys === 'ps1' || sys === 'psx') return 'background:#757575;color:#fff;';
    if (sys.includes('ps4') || sys.includes('playstation 4') || sys.includes('psp') || sys.includes('vita')) return 'background:#003791;color:#fff;';
    if (sys.includes('wii u')) return 'background:#009AC7;color:#fff;';
    if (sys.includes('xbox')) return 'background:#107C10;color:#fff;';
    if (sys.includes('dreamcast')) return 'background:#FF6600;color:#fff;';
    if (sys.includes('sega') || sys.includes('genesis') || sys.includes('saturn')) return 'background:#0060A9;color:#fff;';
    if (sys.includes('atari')) return 'background:#E21A22;color:#fff;';
    if (sys.includes('nintendo') || sys.includes('mario') || sys.includes('switch') || sys.includes('nes') || sys.includes('famicom') || sys.includes('3ds')) return 'background:#E60012;color:#fff;';
    return 'background:#666;color:#fff;';
  }

  function updateSystemFilterOptions() {
    var systems = Array.from(new Set(state.cart.map(function (i) { return i.system; }))).filter(Boolean).sort();
    var cur = state.systemFilter;
    els.sysFilter.innerHTML = '<option value="ALL">All systems</option>';
    systems.forEach(function (s) {
      var opt = document.createElement('option');
      opt.value = s;
      opt.textContent = s;
      els.sysFilter.appendChild(opt);
    });
    if (systems.indexOf(cur) >= 0) els.sysFilter.value = cur;
    else {
      els.sysFilter.value = 'ALL';
      state.systemFilter = 'ALL';
    }
  }

  function visibleCart() {
    if (state.systemFilter === 'ALL') return state.cart;
    return state.cart.filter(function (i) { return i.system === state.systemFilter; });
  }

  function normalizeItem(raw) {
    var item = raw;
    if (!item.title && item.name) item.title = item.name;
    if (!item.ui_id) item.ui_id = Math.random().toString(36).substr(2, 9);
    if (item.selected == null || item.selected === '') {
      item.selected = defaultConditionForSystem(item.system);
    }
    if (item.isGoodCondition == null) {
      item.isGoodCondition = item.cleanBonus === true;
    } else {
      item.isGoodCondition = !!item.isGoodCondition;
    }
    if (!item.imgUrl) item.imgUrl = GENERIC_CART_SVG;
    if (raw.releaseYear != null && raw.releaseYear !== '') {
      var ry = Number(raw.releaseYear);
      if (!isNaN(ry)) item.releaseYear = ry;
    }
    if (isModernCatalogYear(releaseYearFromItem(item)) && item.selected === 'inbox') {
      item.selected = 'cib';
    }
    if (raw.gameScore != null && raw.gameScore !== '') {
      var gs = Number(raw.gameScore);
      if (!isNaN(gs)) item.gameScore = gs;
    }
    if (raw.marketCib != null && raw.marketCib !== '') {
      var mc = Number(raw.marketCib);
      if (!isNaN(mc)) item.marketCib = mc;
    }
    if (raw.salesVolume != null && raw.salesVolume !== '') {
      var sv = Number(raw.salesVolume);
      if (!isNaN(sv)) item.salesVolume = sv;
    }
    item.isHotlist = raw.isHotlist === true || raw.isHotlist === 'true';
    item.tradeStorefrontBlocked = raw.tradeStorefrontBlocked === true;
    return item;
  }

  /** Map trade/search/scan API rows to cart fields; cover art comes from backend `imgUrl` (normalizeItem → GENERIC_CART_SVG if missing). */
  function reshapeCatalogHitForCart(raw) {
    if (!raw) return normalizeItem({});
    var o = Object.assign({}, raw);
    var resolvedSys =
      (o.system != null && String(o.system).trim()) ||
      (raw.system != null && String(raw.system).trim()) ||
      (raw.platformName != null && String(raw.platformName).trim()) ||
      (raw.platform != null && String(raw.platform).trim()) ||
      '';
    if (resolvedSys) o.system = resolvedSys;
    if (o.shopify_gid == null || o.shopify_gid === '') {
      if (o.shopifyGid) o.shopify_gid = o.shopifyGid;
      else if (typeof o.id === 'string' && o.id.indexOf('gid://shopify/Product/') === 0) o.shopify_gid = o.id;
    }
    if (raw.imgUrl != null && String(raw.imgUrl).trim() !== '') {
      o.imgUrl = String(raw.imgUrl).trim();
    }
    var img = o.imgUrl;
    if (img == null || String(img).trim() === '') {
      if (raw.imageUrl) o.imgUrl = String(raw.imageUrl).trim();
      else if (raw.image && typeof raw.image === 'string') o.imgUrl = String(raw.image).trim();
      else if (raw.image && raw.image.url) o.imgUrl = String(raw.image.url).trim();
      else if (raw.featuredImage && raw.featuredImage.url) o.imgUrl = String(raw.featuredImage.url).trim();
      else if (raw.featured_image && raw.featured_image.url) o.imgUrl = String(raw.featured_image.url).trim();
      else if (raw.thumbnail && typeof raw.thumbnail === 'string') o.imgUrl = String(raw.thumbnail).trim();
      else if (raw.thumbnail && raw.thumbnail.url) o.imgUrl = String(raw.thumbnail.url).trim();
      else o.imgUrl = '';
    } else {
      o.imgUrl = String(img).trim();
    }
    return normalizeItem(o);
  }

  function serializeCartForStorage() {
    return state.cart.map(function (i) {
      var row = {
        ui_id: i.ui_id,
        title: i.title,
        name: i.name,
        system: i.system,
        selected: i.selected,
        isGoodCondition: !!i.isGoodCondition,
        pcid: i.pcid,
        shopify_gid: i.shopify_gid,
        offers: i.offers,
        imgUrl: i.imgUrl,
        releaseYear: i.releaseYear,
        gameScore: i.gameScore,
        isHotlist: i.isHotlist,
      };
      if (i.tradeStorefrontBlocked) row.tradeStorefrontBlocked = true;
      return row;
    });
  }

  function loadQuoteIdFromStorage() {
    try {
      var q = localStorage.getItem(TQ_QUOTE_ID_STORAGE_KEY);
      if (q && typeof q === 'string' && q.trim()) _s.storefrontQuoteId = q.trim();
    } catch (e) {}
  }

  function loadCartFromStorage() {
    try {
      var raw = localStorage.getItem(TQ_CART_STORAGE_KEY);
      if (!raw) return;
      var arr = JSON.parse(raw);
      if (!Array.isArray(arr) || !arr.length) return;
      var out = [];
      for (var j = 0; j < arr.length; j++) {
        out.push(normalizeItem(Object.assign({}, arr[j])));
      }
      _s.cart = out;
      root.dataset.hasCart = 'true';
    } catch (e) {}
  }

  function doStorefrontQuoteSync() {
    var lines = inStoreCartLinesForApi();
    if (!lines.length) return;
    var gen = ++storefrontQuoteSyncGen;
    var body = { cart: lines, intent: 'upsert' };
    if (_s.storefrontQuoteId) body.quoteId = _s.storefrontQuoteId;
    fetch(TRADE_IN_STORE_QUOTE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        return res.text().then(function (bodyText) {
          return { res: res, bodyText: bodyText || '' };
        });
      })
      .then(function (_ref) {
        if (gen !== storefrontQuoteSyncGen) return;
        var res = _ref.res;
        var bodyText = _ref.bodyText;
        var data = {};
        try {
          data = bodyText ? JSON.parse(bodyText) : {};
        } catch (e) {
          data = {};
        }
        if (!res.ok) return;
        var qid = typeof data.quoteId === 'string' ? data.quoteId.trim() : '';
        if (!qid) return;
        var changed = qid !== _s.storefrontQuoteId;
        _s.storefrontQuoteId = qid;
        try {
          localStorage.setItem(TQ_QUOTE_ID_STORAGE_KEY, qid);
        } catch (e) {}
        if (changed) notify();
      })
      .catch(function () {});
  }

  function scrollTradeQuoteListToTop() {
    var w = els.sheetListWrap;
    if (w) w.scrollTop = 0;
  }

  /** Keep page / theme scroll from jumping when manual search focuses (camera peek). */
  function nudgeManualSearchViewportTop() {
    try {
      window.scrollTo(0, 0);
    } catch (e) {}
    try {
      if (window.scrollTo) window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    } catch (e) {}
    if (document.documentElement) document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;
    if (root && root.scrollTop !== undefined) root.scrollTop = 0;
    /* Camera: list is the main sheet content — resetting scroll here jumps the games list when focusing search. */
    if (state.view !== 'camera') {
      scrollTradeQuoteListToTop();
    }
  }

  function scheduleNudgeManualSearchViewport() {
    nudgeManualSearchViewportTop();
    requestAnimationFrame(nudgeManualSearchViewportTop);
    if (state.view === 'camera') {
      /* Fewer repeats: avoid fighting iOS keyboard / visualViewport while sheet is already up. */
      setTimeout(nudgeManualSearchViewportTop, 0);
      return;
    }
    requestAnimationFrame(function () {
      requestAnimationFrame(nudgeManualSearchViewportTop);
    });
    setTimeout(nudgeManualSearchViewportTop, 0);
    setTimeout(nudgeManualSearchViewportTop, 80);
    setTimeout(nudgeManualSearchViewportTop, 200);
  }

  function syncPeekAddMoreVisibility() {
    var takePicturesPeek = document.getElementById('tqBtnPeekTakePictures');
    var peekAddMoreCam = document.getElementById('tqBtnPeekAddMoreCamera');
    var searching = els.search && (els.search.value || '').trim().length > 0;
    var searchFocused = els.search && document.activeElement === els.search;
    if (takePicturesPeek) {
      /* Hero sheet: optional camera shortcut; hide during Search Manually sheet mode (no duplicate CTA under search). */
      takePicturesPeek.hidden = !(
        state.view === 'hero' &&
        root.dataset.heroQuoteOpen === 'true' &&
        root.dataset.tqPeekManualSearch !== 'true' &&
        !searching &&
        !catchModalOpen
      );
    }
    if (peekAddMoreCam) {
      /* Camera: same slot/size as Review List — list pulled up → Add More; peek → Review List (renderViews). Hide while searching. */
      var sheetUp = state.sheetSnap === 'full' || state.sheetSnap === 'expanded';
      peekAddMoreCam.hidden = !(
        state.view === 'camera' &&
        state.cart.length > 0 &&
        sheetUp &&
        !searching &&
        !searchFocused &&
        !catchModalOpen
      );
    }
  }

  function addCartItems(items, opts) {
    opts = opts || {};
    var added = [];
    items.forEach(function (g) {
      var copy = reshapeCatalogHitForCart(g);
      state.cart = [copy].concat(state.cart);
      added.push(copy);
    });
    root.dataset.hasCart = state.cart.length ? 'true' : 'false';
    updateSystemFilterOptions();
    if (state.view === 'hero' && added.length) {
      root.dataset.heroQuoteOpen = 'true';
    }
    if (opts.sheetSnap != null) {
      state.sheetSnap = opts.sheetSnap;
    } else if (state.view === 'hero' || state.view === 'camera') {
      state.sheetSnap = 'peek';
    }
    if (opts.flyFromRect && added[0]) {
      flyThumbFromRect(added[0].imgUrl || GENERIC_CART_SVG, opts.flyFromRect);
    } else if (opts.flyImg && added[0]) {
      flyThumbToSheet(opts.flyImg, added[0].imgUrl || GENERIC_CART_SVG);
    }
    if (opts.vibrate !== false) haptic();
    render();
    var t = cartTotals();
    animateTotalsTo(t.credit, t.cash);
    if (opts.toast) showToast(opts.toast);
    if (opts.scrollQuoteListToTop) {
      requestAnimationFrame(function () {
        scrollTradeQuoteListToTop();
      });
    }
    if (opts.blurSheetSearch && els.search && document.activeElement === els.search) {
      els.search.blur();
    }
    if (opts.blurSheetSearch) {
      requestAnimationFrame(function () {
        if (els.search && document.activeElement === els.search) els.search.blur();
      });
    }
  }

  function removeFromCart(uiId) {
    state.cart = state.cart.filter(function (i) { return i.ui_id !== uiId; });
    root.dataset.hasCart = state.cart.length ? 'true' : 'false';
    if (!state.cart.length) {
      state.sheetSnap = 'peek';
      delete root.dataset.heroQuoteOpen;
      root.dataset.tqPeekManualSearch = 'false';
      var hTogRm = document.getElementById('tqHeroSearchToggle');
      if (hTogRm) hTogRm.setAttribute('aria-expanded', 'false');
    }
    updateSystemFilterOptions();
    render();
    var t = cartTotals();
    animateTotalsTo(t.credit, t.cash);
  }

  /** Clear cart, storage, and search UI (no render). Ongoing quote is only restored via Resume after load. */
  function clearTradeQuoteData() {
    try {
      localStorage.removeItem(TQ_CART_STORAGE_KEY);
      localStorage.removeItem(TQ_QUOTE_ID_STORAGE_KEY);
    } catch (e) {}
    _s.storefrontQuoteId = '';
    _s.inStoreQrSig = '';
    _s.inStoreQrPayload = '';
    _s.inStoreQrPending = false;
    _s.inStoreQrPendingForSig = '';
    _s.inStoreQrError = '';
    _s.inStoreQrFailedSig = '';
    state.cart = [];
    root.dataset.hasCart = 'false';
    state.sheetSnap = 'peek';
    state.conditionGateDone = true;
    delete root.dataset.heroQuoteOpen;
    root.dataset.tqPeekManualSearch = 'false';
    var hClr = document.getElementById('tqHeroSearchPanel');
    var tClr = document.getElementById('tqHeroSearchToggle');
    if (hClr) hClr.hidden = true;
    if (tClr) tClr.setAttribute('aria-expanded', 'false');
    var heroInp = document.getElementById('tqSearchHero');
    var heroDd = document.getElementById('tqSearchDropdownHero');
    if (heroInp) heroInp.value = '';
    if (heroDd) {
      heroDd.hidden = true;
      heroDd.innerHTML = '';
    }
    if (els.search) els.search.value = '';
    if (els.searchDd) {
      els.searchDd.hidden = true;
      els.searchDd.innerHTML = '';
    }
    updateSystemFilterOptions();
  }

  function resetTradeQuote() {
    clearTradeQuoteData();
    render();
    animateTotalsTo(0, 0);
  }

  var TQ_IMPORT_MAX_LINES = 200;
  var TQ_IMPORT_PREFIX = 'TQIMPORT';

  function tqImportTrim(s) {
    return typeof s === 'string' ? s.trim() : '';
  }

  function mapPriceChartingCondition(raw) {
    var s = tqImportTrim(raw).toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
    if (!s) return 'loose';
    if (s === 'loose' || s === 'l' || s === 'cart only' || s === 'disc only' || s === 'item only' || s === 'cart/disc only') {
      return 'loose';
    }
    if (s === 'inbox' || s === 'in box' || s === 'b' || s === 'box only' || s === 'incomplete' || s === 'item and manual') {
      return 'inbox';
    }
    if (
      s === 'cib' ||
      s === 'c' ||
      s === 'complete' ||
      s === 'complete in box' ||
      s === 'item and box' ||
      s === 'new' ||
      s === 'sealed' ||
      s === 'new (sealed)' ||
      s === 'brand new' ||
      s === 'new and sealed' ||
      s === 'graded sealed'
    ) {
      return 'cib';
    }
    return 'loose';
  }

  function utf8ToBase64Url(str) {
    var bytes = unescape(encodeURIComponent(str));
    return btoa(bytes).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  function base64UrlToUtf8(s) {
    var b64 = String(s || '').replace(/-/g, '+').replace(/_/g, '/');
    while (b64.length % 4) b64 += '=';
    return decodeURIComponent(escape(atob(b64)));
  }

  function parseIsqQuoteId(raw) {
    var compact = tqImportTrim(raw).replace(/\s/g, '');
    var piped = /^ISQ\|(.+)$/i.exec(compact);
    var id = (piped && piped[1] ? piped[1] : compact).trim();
    if (/^ISQ-[A-Fa-f0-9]+$/i.test(id)) return id.toUpperCase().replace(/^ISQ-/, 'ISQ-');
    return null;
  }

  function parseV1ToImportLines(v1) {
    var s = tqImportTrim(v1);
    if (s.toUpperCase().indexOf('V1|') !== 0) return [];
    var lines = [];
    var segments = s.split('|');
    var i;
    for (i = 1; i < segments.length; i++) {
      var match = /^([^:]+):([LBC])T?:[01]$/i.exec(segments[i] || '');
      if (!match) continue;
      var pcid = match[1].trim();
      if (!pcid) continue;
      var letter = match[2].toUpperCase();
      lines.push({ pcid: pcid, selected: letter === 'B' ? 'inbox' : letter === 'C' ? 'cib' : 'loose' });
    }
    return lines;
  }

  function lineFromImportObject(raw) {
    if (!raw || typeof raw !== 'object') return null;
    var pcid = tqImportTrim(raw.pcid) || tqImportTrim(raw.id);
    if (!pcid) return null;
    return { pcid: pcid, selected: mapPriceChartingCondition(raw.selected) };
  }

  function parseTqImportJsonObject(obj) {
    if (!obj || typeof obj !== 'object') return { ok: false, error: 'Paste JSON or a TQIMPORT code.' };
    if (obj.v != null && obj.v !== 1 && obj.v !== '1') return { ok: false, error: 'Unsupported import version.' };
    if (!Array.isArray(obj.lines)) return { ok: false, error: 'Import JSON needs a lines array.' };
    if (obj.lines.length > TQ_IMPORT_MAX_LINES) {
      return { ok: false, error: 'Too many lines (max ' + TQ_IMPORT_MAX_LINES + ').' };
    }
    var lines = [];
    var i;
    for (i = 0; i < obj.lines.length; i++) {
      var line = lineFromImportObject(obj.lines[i]);
      if (line) lines.push(line);
    }
    if (!lines.length) return { ok: false, error: 'No games found in that import.' };
    return { ok: true, kind: 'json', payload: { v: 1, lines: lines } };
  }

  function encodeTqImportCodeFromCart() {
    var lines = [];
    state.cart.forEach(function (i) {
      var pcid = tqImportTrim(i.pcid);
      if (!pcid) return;
      var sel = i.selected === 'inbox' || i.selected === 'cib' ? i.selected : 'loose';
      lines.push({ pcid: pcid, selected: sel });
    });
    if (!lines.length) return '';
    return TQ_IMPORT_PREFIX + '|1|' + utf8ToBase64Url(JSON.stringify({ v: 1, source: 'pricecharting', lines: lines }));
  }

  function parseTqImportPaste(raw) {
    var trimmed = tqImportTrim(raw);
    if (!trimmed) return { ok: false, error: 'Paste a code or JSON to import.' };
    var isq = parseIsqQuoteId(trimmed);
    if (isq) return { ok: true, kind: 'isq', quoteId: isq };
    var compact = trimmed.replace(/\s/g, '');
    var code = new RegExp('^' + TQ_IMPORT_PREFIX + '\\|1\\|([A-Za-z0-9_-]+)$', 'i').exec(compact);
    if (code) {
      var json;
      try {
        json = base64UrlToUtf8(code[1]);
      } catch (e) {
        return { ok: false, error: 'Could not decode that import code.' };
      }
      var obj;
      try {
        obj = JSON.parse(json);
      } catch (e2) {
        return { ok: false, error: 'Import code is not valid JSON.' };
      }
      var parsed = parseTqImportJsonObject(obj);
      if (!parsed.ok) return parsed;
      parsed.kind = 'compact';
      return parsed;
    }
    if (trimmed.charAt(0) === '{') {
      var obj2;
      try {
        obj2 = JSON.parse(trimmed);
      } catch (e3) {
        return { ok: false, error: 'That JSON could not be parsed.' };
      }
      return parseTqImportJsonObject(obj2);
    }
    return { ok: false, error: 'Paste a TQIMPORT code, JSON, or an ISQ store pass.' };
  }

  function clearStorefrontQuoteId() {
    _s.storefrontQuoteId = '';
    _s.inStoreQrSig = '';
    _s.inStoreQrPayload = '';
    _s.inStoreQrPending = false;
    _s.inStoreQrPendingForSig = '';
    _s.inStoreQrError = '';
    _s.inStoreQrFailedSig = '';
    try {
      localStorage.removeItem(TQ_QUOTE_ID_STORAGE_KEY);
    } catch (e) {}
  }

  function replaceCartFromImport(items) {
    clearStorefrontQuoteId();
    state.cart = items;
    root.dataset.hasCart = items.length ? 'true' : 'false';
    if (items.length) {
      root.dataset.heroQuoteOpen = 'true';
      if (state.view === 'hero' || state.view === 'camera') {
        state.sheetSnap = 'peek';
      }
    }
    updateSystemFilterOptions();
    render();
    var t = cartTotals();
    animateTotalsTo(t.credit, t.cash);
  }

  function skipLabelForReason(reason) {
    if (reason === 'not_found') return 'not found';
    if (reason === 'blocked' || reason === 'low_score') return 'blocked';
    return reason || 'skipped';
  }

  function applyResolvedHitsToCart(requestedLines, results, skippedFromServer) {
    var byPcid = {};
    (results || []).forEach(function (hit) {
      if (hit && hit.pcid) byPcid[String(hit.pcid)] = hit;
    });
    var skippedMap = {};
    (skippedFromServer || []).forEach(function (s) {
      if (s && s.pcid) skippedMap[String(s.pcid)] = s.reason || 'not_found';
    });
    var imported = [];
    var skipped = [];
    var i;
    for (i = 0; i < requestedLines.length; i++) {
      var line = requestedLines[i];
      var pcid = String(line.pcid);
      if (skippedMap[pcid]) {
        skipped.push({ pcid: pcid, reason: skippedMap[pcid] });
        continue;
      }
      var hit = byPcid[pcid];
      if (!hit) {
        skipped.push({ pcid: pcid, reason: 'not_found' });
        continue;
      }
      var item = reshapeCatalogHitForCart(Object.assign({}, hit, { selected: line.selected || 'loose' }));
      var block = tradeSearchBlockReason(item);
      if (block === 'low_score') {
        skipped.push({ pcid: pcid, reason: 'blocked' });
        continue;
      }
      imported.push(item);
    }
    if (!imported.length) {
      showToast('No games imported. ' + skipped.length + ' skipped.', TQ_TOAST_ERROR_MS);
      return false;
    }
    replaceCartFromImport(imported);
    var msg = 'Imported ' + imported.length + ' game' + (imported.length === 1 ? '' : 's');
    if (skipped.length) {
      var counts = {};
      skipped.forEach(function (s) {
        var k = skipLabelForReason(s.reason);
        counts[k] = (counts[k] || 0) + 1;
      });
      var bits = Object.keys(counts).map(function (k) {
        return counts[k] + ' ' + k;
      });
      msg += ' (' + skipped.length + ' skipped: ' + bits.join(', ') + ')';
      showToast(msg, TQ_TOAST_ERROR_MS);
    } else {
      showToast(msg);
    }
    return true;
  }

  function resolveImportLines(lines) {
    return fetch(TRADE_CALC_RESOLVE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        lines: lines.map(function (l) {
          return { pcid: l.pcid, selected: l.selected };
        }),
      }),
    }).then(function (res) {
      return res.json().then(function (data) {
        return { res: res, data: data || {} };
      });
    });
  }

  function fetchIsqImportLines(quoteId) {
    return fetch(TRADE_IN_STORE_QUOTE_URL + '?quoteId=' + encodeURIComponent(quoteId)).then(function (res) {
      return res.json().then(function (data) {
        return { res: res, data: data || {} };
      });
    });
  }

  function setImportModalBusy(busy) {
    var submit = document.getElementById('tqImportSubmit');
    var paste = document.getElementById('tqImportPaste');
    if (submit) submit.disabled = !!busy;
    if (paste) paste.disabled = !!busy;
  }

  function closeImportModal() {
    var modal = document.getElementById('tqImportModal');
    if (modal) modal.hidden = true;
  }

  function openImportModal() {
    var modal = document.getElementById('tqImportModal');
    var paste = document.getElementById('tqImportPaste');
    var copyBtn = document.getElementById('tqImportCopy');
    if (!modal) return;
    modal.hidden = false;
    if (copyBtn) copyBtn.hidden = !state.cart.length;
    if (paste) {
      paste.value = '';
      setTimeout(function () {
        try {
          paste.focus();
        } catch (e) {}
      }, 30);
    }
  }

  function runCartImport() {
    var paste = document.getElementById('tqImportPaste');
    var parsed = parseTqImportPaste(paste ? paste.value : '');
    if (!parsed.ok) {
      showToast(parsed.error, TQ_TOAST_ERROR_MS);
      return;
    }
    setImportModalBusy(true);

    function finishOk() {
      setImportModalBusy(false);
      closeImportModal();
    }
    function finishErr(msg) {
      setImportModalBusy(false);
      showToast(msg, TQ_TOAST_ERROR_MS);
    }

    if (parsed.kind === 'isq') {
      fetchIsqImportLines(parsed.quoteId)
        .then(function (out) {
          if (!out.res.ok) {
            finishErr(out.data.error || 'Store pass not found.');
            return;
          }
          var lines = Array.isArray(out.data.lines) ? out.data.lines : parseV1ToImportLines(out.data.v1 || '');
          if (!lines.length) {
            finishErr("Store pass codes can't be imported here — they are for in-store claim only.");
            return;
          }
          var normLines = [];
          lines.forEach(function (row) {
            var line = lineFromImportObject(row);
            if (line) normLines.push(line);
          });
          if (!normLines.length) {
            finishErr("Store pass codes can't be imported here — they are for in-store claim only.");
            return;
          }
          return resolveImportLines(normLines).then(function (resolved) {
            if (!resolved.res.ok) {
              finishErr(resolved.data.error || 'Could not look up those games.');
              return;
            }
            if (applyResolvedHitsToCart(normLines, resolved.data.results, resolved.data.skipped)) finishOk();
            else setImportModalBusy(false);
          });
        })
        .catch(function () {
          finishErr('Could not load that store pass.');
        });
      return;
    }

    var payloadLines = parsed.payload && parsed.payload.lines ? parsed.payload.lines : [];
    resolveImportLines(payloadLines)
      .then(function (resolved) {
        if (!resolved.res.ok) {
          finishErr(resolved.data.error || 'Could not look up those games.');
          return;
        }
        if (applyResolvedHitsToCart(payloadLines, resolved.data.results, resolved.data.skipped)) finishOk();
        else setImportModalBusy(false);
      })
      .catch(function () {
        finishErr('Could not look up those games.');
      });
  }

  function copyCurrentCartImportCode() {
    var code = encodeTqImportCodeFromCart();
    if (!code) {
      showToast('Add games to the quote before copying a code.');
      return;
    }
    function copied() {
      showToast('Import code copied.');
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(copied).catch(function () {
        showToast(code, TQ_TOAST_ERROR_MS);
      });
      return;
    }
    showToast(code, TQ_TOAST_ERROR_MS);
  }

  function bindImportUi() {
    ['tqImportOpenHero', 'tqImportOpenSheet'].forEach(function (id) {
      var btn = document.getElementById(id);
      if (btn) btn.addEventListener('click', openImportModal);
    });
    var cancel = document.getElementById('tqImportCancel');
    var submit = document.getElementById('tqImportSubmit');
    var copyBtn = document.getElementById('tqImportCopy');
    var modal = document.getElementById('tqImportModal');
    if (cancel) cancel.addEventListener('click', closeImportModal);
    if (submit) submit.addEventListener('click', runCartImport);
    if (copyBtn) copyBtn.addEventListener('click', copyCurrentCartImportCode);
    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeImportModal();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var m = document.getElementById('tqImportModal');
      if (m && !m.hidden) closeImportModal();
    });
  }

  function setCondition(uiId, cond) {
    var item = state.cart.find(function (i) { return i.ui_id === uiId; });
    if (!item) return;
    var y = releaseYearFromItem(item);
    if (isModernCatalogYear(y) && cond === 'inbox') {
      cond = 'cib';
    }
    item.selected = cond;
    render();
    var t = cartTotals();
    animateTotalsTo(t.credit, t.cash);
  }

  function flyThumbToSheet(imageUrl, thumbUrl) {
    var img = document.createElement('img');
    img.src = thumbUrl || imageUrl || GENERIC_CART_SVG;
    img.className = 'tq-fly-thumb';
    img.style.cssText = 'position:fixed;width:120px;height:160px;object-fit:contain;border-radius:6px;box-shadow:0 24px 60px rgba(0,0,0,0.35);z-index:5001;left:50%;top:38%;transform:translate(-50%,-50%) scale(0.6);transition:transform 0.65s cubic-bezier(0.22,1,0.36,1),opacity 0.65s ease,top 0.65s cubic-bezier(0.22,1,0.36,1),left 0.65s cubic-bezier(0.22,1,0.36,1);pointer-events:none;';
    els.flyLayer.appendChild(img);
    requestAnimationFrame(function () {
      var target = els.sheetPeek || els.sheet;
      var r = target ? target.getBoundingClientRect() : { left: window.innerWidth / 2, top: window.innerHeight - 80 };
      img.style.left = r.left + r.width / 2 + 'px';
      img.style.top = r.top + r.height / 2 + 'px';
      img.style.transform = 'translate(-50%,-50%) scale(0.22)';
      img.style.opacity = '0.85';
    });
    setTimeout(function () {
      if (img.parentNode) img.parentNode.removeChild(img);
    }, 700);
  }

  function flyThumbFromRect(thumbUrl, rect) {
    var img = document.createElement('img');
    img.src = thumbUrl || GENERIC_CART_SVG;
    img.className = 'tq-fly-thumb';
    var cx = rect.left + rect.width / 2;
    var cy = rect.top + rect.height / 2;
    img.style.cssText = 'position:fixed;width:120px;height:160px;object-fit:contain;border-radius:6px;box-shadow:0 24px 60px rgba(0,0,0,0.35);z-index:5001;left:' + cx + 'px;top:' + cy + 'px;transform:translate(-50%,-50%) scale(0.5);transition:transform 0.65s cubic-bezier(0.22,1,0.36,1),opacity 0.65s ease,top 0.65s cubic-bezier(0.22,1,0.36,1),left 0.65s cubic-bezier(0.22,1,0.36,1);pointer-events:none;';
    els.flyLayer.appendChild(img);
    requestAnimationFrame(function () {
      var target = els.sheetPeek || els.sheet;
      var r = target ? target.getBoundingClientRect() : { left: window.innerWidth / 2, top: window.innerHeight - 80 };
      img.style.left = r.left + r.width / 2 + 'px';
      img.style.top = r.top + r.height / 2 + 'px';
      img.style.transform = 'translate(-50%,-50%) scale(0.22)';
      img.style.opacity = '0.85';
    });
    setTimeout(function () {
      if (img.parentNode) img.parentNode.removeChild(img);
    }, 700);
  }

  function getSnapHeightsPx() {
    var st = getComputedStyle(root);
    var peek = parseFloat(st.getPropertyValue('--tq-sheet-peek')) || 32;
    var mid = parseFloat(st.getPropertyValue('--tq-sheet-mid')) || 58;
    var full = parseFloat(st.getPropertyValue('--tq-sheet-full')) || 100;
    var vh = window.innerHeight / 100;
    return { peek: peek * vh, mid: mid * vh, full: full * vh };
  }

  function openPxForSnap(snap) {
    var h = getSnapHeightsPx();
    if (snap === 'peek') return h.peek;
    if (snap === 'expanded') return h.mid;
    return h.full;
  }

  /** Pixels of layout viewport below the visual viewport (e.g. iOS software keyboard). */
  function getVisualViewportBottomInset() {
    var vv = window.visualViewport;
    if (!vv) return 0;
    var ih = window.innerHeight || (document.documentElement && document.documentElement.clientHeight) || 0;
    return Math.max(0, Math.round(ih - vv.offsetTop - vv.height));
  }

  function applySheetTransform(fromResize) {
    if (!els.sheet) return;
    if (fromResize && sheetResizeLocked) return;
    var openPx = openPxForSnap(state.sheetSnap);
    var minO = window.innerHeight * 0.2;
    var maxO = window.innerHeight;
    openPx = Math.max(minO, Math.min(maxO, openPx));
    if (els.sheet.offsetHeight > 0) {
      openPx = Math.min(openPx, els.sheet.offsetHeight);
    }
    var vvInset = getVisualViewportBottomInset();
    if (root.dataset.catchTitleEditing === 'true') vvInset = 0;
    else if (root.dataset.checkoutOpen === 'true') {
      /* Checkout modal (mail address/payment): do not lift the quote sheet with the keyboard — iOS would expose the game list behind a shrinking overlay. */
      vvInset = 0;
    } else if (root.dataset.tqPeekManualSearch === 'true') {
      /* Sheet search focused: cap keyboard inset so the peek strip (search field) stays in the visual viewport. Full inset + full-height sheet translates the whole panel up and hides the bar — especially camera + expanded game list on iOS. */
      vvInset = Math.min(vvInset, Math.round(window.innerHeight * 0.12));
    }
    root.style.setProperty('--sheet-open', String(openPx));
    root.style.setProperty('--tq-vv-bottom-inset', String(vvInset));
    var tf = 'translateY(calc(100% - ' + openPx + 'px - ' + vvInset + 'px))';
    if (window.innerWidth >= 768) tf = 'translateX(-50%) ' + tf;
    els.sheet.style.transform = tf;
  }

  function onSheetViewportResize() {
    applySheetTransform(true);
  }

  function mountSheetKeyboardFix() {
    if (!els.sheet) return;
    var vv = window.visualViewport;
    function onVisualViewportMove() {
      applySheetTransform(false);
    }
    if (vv) {
      vv.addEventListener('resize', onVisualViewportMove);
      vv.addEventListener('scroll', onVisualViewportMove);
    }
    window.addEventListener('resize', onVisualViewportMove);
    els.sheet.addEventListener('focusin', function (e) {
      if (root.dataset.catchTitleEditing === 'true') return;
      var t = e.target;
      if (!t.matches || !t.matches('input, textarea, select')) return;
      sheetResizeLocked = true;
      if (t.id === 'tqSearch') {
        root.dataset.tqPeekManualSearch = 'true';
      }
      if (t.id === 'tqSearch' && state.view === 'camera') {
        /* Only lift from peek — if user already pulled full/expanded for the list, do not snap shorter. */
        if (state.sheetSnap === 'peek') {
          state.sheetSnap = 'expanded';
        }
      } else {
        state.sheetSnap = 'full';
      }
      applySheetTransform(false);
      if (t.id === 'tqSearch' && state.view === 'camera') {
        scheduleNudgeManualSearchViewport();
      }
    });
    els.sheet.addEventListener('focusout', function () {
      setTimeout(function () {
        var ae = document.activeElement;
        if (ae && els.sheet.contains(ae) && ae.matches && ae.matches('input, textarea, select')) return;
        sheetResizeLocked = false;
        applySheetTransform(false);
      }, 50);
    });
  }

  function syncSheetGrabberAria() {
    var g = document.getElementById('tqSheetGrabber');
    if (!g) return;
    var expanded = state.sheetSnap !== 'peek';
    g.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    g.setAttribute('aria-label', expanded ? 'Tap to collapse quote sheet' : 'Tap to expand quote sheet');
  }

  function mountSheetToggle() {
    var grabber = document.getElementById('tqSheetGrabber');
    if (!grabber || grabber.dataset.tqToggleMounted) return;
    grabber.dataset.tqToggleMounted = '1';
    grabber.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      hapticLight();
      if (state.view === 'hero' && !state.cart.length && state.sheetSnap !== 'peek') {
        dismissHeroSheetIfNoQuote();
        return;
      }
      if (state.sheetSnap === 'full') state.sheetSnap = 'peek';
      else state.sheetSnap = 'full';
    });
  }

  function mountSheetPeekSwipe() {
    var peek = els.sheetPeek;
    if (!peek || peek.dataset.tqPeekSwipeMounted) return;
    peek.dataset.tqPeekSwipeMounted = '1';
    var startY = 0;
    var startX = 0;
    var tracking = false;
    peek.addEventListener(
      'touchstart',
      function (e) {
        if (state.sheetSnap !== 'peek') return;
        if (!e.touches || !e.touches.length) return;
        tracking = true;
        startY = e.touches[0].clientY;
        startX = e.touches[0].clientX;
      },
      { passive: true }
    );
    peek.addEventListener(
      'touchend',
      function (e) {
        if (!tracking) return;
        tracking = false;
        if (state.sheetSnap !== 'peek') return;
        if (!e.changedTouches || !e.changedTouches.length) return;
        var dy = startY - e.changedTouches[0].clientY;
        var dx = Math.abs(e.changedTouches[0].clientX - startX);
        if (dy > 48 && dx < 110) {
          hapticLight();
          state.sheetSnap = 'full';
          render();
        }
      },
      { passive: true }
    );
  }

  function updateSearchPlaceholder() {
    if (!els.search) return;
    if (state.view === 'camera') {
      els.search.placeholder = 'Search games manually';
      els.search.setAttribute('aria-label', 'Search games manually');
    } else {
      els.search.placeholder = 'Search by game name';
      els.search.setAttribute('aria-label', 'Search by game name');
    }
  }

  /** iOS / mobile often pause the preview when the sheet expands or the tab backgrounds; nudge play() when we return. */
  function resumeLiveCameraPreview() {
    if (state.view !== 'camera') return;
    var host = els.cameraHost;
    if (!host) return;
    var video = host.querySelector('video');
    if (!video || !video.srcObject) return;
    try {
      var pp = video.play();
      if (pp && typeof pp.catch === 'function') pp.catch(function () {});
    } catch (e) {}
  }

  function renderViews() {
    root.dataset.view = state.view;
    root.dataset.sheetSnap = state.sheetSnap;
    root.dataset.conditionGateDone = state.conditionGateDone ? 'true' : 'false';
    document.querySelectorAll('.tq-view').forEach(function (v) {
      var name = v.getAttribute('data-tq-view');
      v.hidden = name !== state.view;
    });
    var scanDock = document.getElementById('tqCameraScanDock');
    if (scanDock) scanDock.setAttribute('aria-hidden', state.view !== 'camera' ? 'true' : 'false');
    var sheetStep = document.getElementById('tqSheetStepLabel');
    if (sheetStep) sheetStep.hidden = state.view === 'camera' || state.view === 'hero';
    if (state.view === 'hero') {
      var introH = document.getElementById('tqHeroIntro');
      if (introH) introH.hidden = false;
    }
    updateSearchPlaceholder();
    syncCameraStepBanner();
    root.dataset.checkoutOpen = state.checkoutStep ? 'true' : 'false';
    applySheetTransform();
    syncSheetGrabberAria();
    var heroHint = document.getElementById('tqHeroHint');
    if (heroHint) {
      heroHint.hidden = !(state.view === 'hero' && state.cart.length > 0);
    }
    var peekReview = document.getElementById('tqPeekReviewList');
    if (peekReview) {
      var hasQuoteGames = state.cart.length > 0;
      peekReview.hidden = !(
        state.view === 'camera' &&
        hasQuoteGames &&
        state.sheetSnap === 'peek'
      );
    }
    syncPeekAddMoreVisibility();
    syncCameraScanTipVisibility();
    if (state.view === 'camera') {
      requestAnimationFrame(function () {
        resumeLiveCameraPreview();
      });
    }
  }

  function syncCameraScanTipVisibility() {
    var tip = document.getElementById('tqCameraScanTip');
    if (!tip) return;
    if (state.view !== 'camera') {
      tip.hidden = true;
      return;
    }
    var t = cartTotals();
    var zeroQuote = t.cash <= 0 && t.credit <= 0;
    tip.hidden = !zeroQuote;
  }

  /**
   * Request smaller Shopify CDN images for list/peek thumbs (~50px CSS) so downloads are faster.
   * Leaves data URLs, non-Shopify hosts, and URLs that already specify width unchanged.
   */
  function coverThumbUrlForSmallCard(rawUrl) {
    var u = String(rawUrl || '').trim();
    if (!u || u.indexOf('data:') === 0) return u;
    try {
      var parsed = new URL(u);
      var h = parsed.hostname;
      if (h.indexOf('cdn.shopify.com') === -1 && h.indexOf('shopifycdn.net') === -1) return u;
      if (/[?&]width=\d/.test(u)) return u;
      parsed.searchParams.set('width', '200');
      return parsed.toString();
    } catch (e) {
      return u;
    }
  }

  function buildGameCard(item, opts) {
    opts = opts || {};
    var p = linePrices(item);
    var pill = getSystemStyle(item.system);
    var modern = isModernCatalogYear(releaseYearFromItem(item));
    var looseL = getLooseConditionLabel(item.system);
    var loose = item.selected === 'loose' ? ' is-on' : '';
    var inboxOn = (!modern && item.selected === 'inbox') || (modern && item.selected === 'cib');
    var inbox = inboxOn ? ' is-on' : '';
    var cib = !modern && item.selected === 'cib' ? ' is-on' : '';
    var lowScore = isStorefrontTradeScoreOrCatalogBlocked(item);
    var inPersonCash = !lowScore && needsInPersonCashOffer(item);
    var hot = itemIsHotlist(item);
    var inboxLbl = getInboxTierLabel(item.system);
    var cibLbl = getCibTierLabel(item.system);
    var footRowClass = 'tq-game-card-foot-row' + (opts.listReview ? ' tq-game-card-foot-row--list' : '');
    var card = document.createElement('div');
    card.className =
      'tq-game-card' +
      (opts.peekStrip ? ' tq-game-card--peek-strip' : '') +
      (opts.listReview ? ' tq-game-card--list-review' : '') +
      (lowScore ? ' tq-game-card--score-reject' : '') +
      (inPersonCash ? ' tq-game-card--in-person-cash' : '');
    card.dataset.uiId = item.ui_id;
    if (opts.listReview) card.setAttribute('data-tq-title-lines', '1');
    var rawThumb = item.imgUrl || GENERIC_CART_SVG;
    var thumbSrc = coverThumbUrlForSmallCard(rawThumb);
    var loadAttr = opts.peekStrip
      ? ' loading="eager" fetchpriority="high"'
      : opts.listReview
        ? ' loading="lazy"'
        : '';
    var thumbHtml =
      '<img class="tq-game-card-thumb" alt="" src="' +
      escapeHtml(thumbSrc) +
      '" decoding="async"' +
      loadAttr +
      '>';
    var titleHead =
      '<div class="tq-game-card-head tq-game-card-head--stack">' +
      '<p class="tq-game-card-title">' +
      escapeHtml(item.title || '') +
      (hot ? '<span class="tq-hotlist-badge tq-hotlist-badge--inline" title="Boosted Offer"> 🔥</span>' : '') +
      '</p>' +
      '</div>';
    var topRowInner = opts.listReview
      ? '<div class="tq-game-card-title-stack">' +
        titleHead +
        '<span class="tq-sys-pill tq-game-card-sys" style="' +
        pill +
        '">' +
        escapeHtml(item.system || '') +
        '</span>' +
        '</div>' +
        '<button type="button" class="tq-game-card-del" data-action="del" aria-label="Remove">×</button>'
      : titleHead + '<button type="button" class="tq-game-card-del" data-action="del" aria-label="Remove">×</button>';
    var sysPillAfterTop = opts.listReview
      ? ''
      : '<span class="tq-sys-pill tq-game-card-sys" style="' + pill + '">' + escapeHtml(item.system || '') + '</span>';
    card.innerHTML =
      thumbHtml +
      '<div class="tq-game-card-body">' +
        '<div class="tq-game-card-top">' +
        topRowInner +
        '</div>' +
        sysPillAfterTop +
        '<div class="tq-card-prices tq-game-card-prices">' +
          '<div><small>Cash offer</small><span>' + formatMoneyPlain(p.cash) + '</span></div>' +
          '<div><small>Credit offer</small><span>' + formatMoneyPlain(p.credit) + '</span></div>' +
        '</div>' +
        (lowScore
          ? '<p class="tq-game-card-score-warn">Not included in your total — we are not taking this title right now. Remove it to continue.</p>'
          : '') +
        (inPersonCash
          ? '<p class="tq-game-card-score-warn">Not included in your total — we don\'t know enough about this game for a cash offer online. Bring it in-person for an offer!</p>'
          : '') +
      '</div>' +
        '<div class="tq-game-card-foot">' +
        '<div class="' + footRowClass + '">' +
          '<div class="tq-seg-cond tq-seg-cond--dense' + (modern ? ' tq-seg-cond--modern' : '') + '">' +
            '<button type="button" data-cond="loose" class="' + loose.trim() + '">' + escapeHtml(looseL) + '</button>' +
            '<button type="button" data-cond="inbox" class="' + inbox.trim() + '">' + escapeHtml(inboxLbl) + '</button>' +
            '<button type="button" data-cond="cib" class="' + cib.trim() + '"' + (modern ? ' hidden' : '') + '>' + escapeHtml(cibLbl) + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    card.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-action="del"]')) {
        removeFromCart(item.ui_id);
        return;
      }
      var condBtn = t.closest('[data-cond]');
      if (condBtn) {
        hapticLight();
        setCondition(item.ui_id, condBtn.getAttribute('data-cond'));
      }
    });
    return card;
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function searchDdLabel(item) {
    if (!item) return '—';
    var label = item.title || item.name || '—';
    var sys = item.system || '—';
    var mark = itemIsHotlist(item) ? '🔥 ' : '';
    return mark + label + ' — ' + sys;
  }

  /** Reasons manual / title search cannot add to quote as a normal online line (copy for UI). */
  function tradeSearchBlockReason(norm) {
    if (!norm) return null;
    if (isStorefrontTradeCatalogBlocked(norm) || isLowTradeGameScore(norm)) return 'low_score';
    if (needsInPersonCashOffer(norm)) return 'in_person';
    return null;
  }

  function tradeSearchBlockSubtext(reason) {
    if (reason === 'low_score') {
      return 'Not accepted online for trade at this time.';
    }
    if (reason === 'in_person') {
      return 'No online cash quote — bring this game in store for a cash offer.';
    }
    return '';
  }

  /**
   * @param {object} item - API search row
   * @param {number} idx
   * @param {object} opts - optional forCartAdd (boolean); if true, blocked rows are non-clickable; if false (title pick), still clickable with warning line
   */
  function searchDdRowHtml(item, idx, opts) {
    opts = opts || {};
    var forCartAdd = !!opts.forCartAdd;
    var norm = reshapeCatalogHitForCart(item);
    var reason = tradeSearchBlockReason(norm);
    var main = escapeHtml(searchDdLabel(item));
    var subRaw = reason ? tradeSearchBlockSubtext(reason) : '';
    var sub = subRaw ? '<span class="tq-dd-item-sub">' + escapeHtml(subRaw) + '</span>' : '';
    if (forCartAdd && reason) {
      return (
        '<div class="tq-dd-item tq-dd-item--blocked" role="note" data-dd-blocked="1" aria-disabled="true">' +
        '<span class="tq-dd-item-main">' +
        main +
        '</span>' +
        sub +
        '</div>'
      );
    }
    var btnClass = 'tq-dd-item' + (reason ? ' tq-dd-item--warn-sub' : '');
    return (
      '<button type="button" class="' +
      btnClass +
      '" data-idx="' +
      idx +
      '"><span class="tq-dd-item-main">' +
      main +
      '</span>' +
      sub +
      '</button>'
    );
  }

  function syncListReviewCardTitleDensity(card) {
    if (!card || !card.classList.contains('tq-game-card--list-review')) return;
    var title = card.querySelector('.tq-game-card-title');
    if (!title) return;
    var lhPx = parseFloat(getComputedStyle(title).lineHeight);
    if (!isFinite(lhPx) || lhPx <= 0) {
      var fs = parseFloat(getComputedStyle(title).fontSize);
      lhPx = (isFinite(fs) ? fs : 14) * 1.2;
    }
    var lines = Math.round(title.scrollHeight / lhPx);
    lines = Math.max(1, Math.min(4, lines));
    card.setAttribute('data-tq-title-lines', lines >= 3 ? '3' : String(lines));
  }

  function syncAllListReviewCardDensities() {
    if (!els.sheetList) return;
    var cards = els.sheetList.querySelectorAll('.tq-game-card--list-review');
    for (var i = 0; i < cards.length; i++) syncListReviewCardTitleDensity(cards[i]);
  }

  var listReviewDensityRo = null;
  function mountListReviewDensityObserver() {
    if (mountListReviewDensityObserver._done) return;
    mountListReviewDensityObserver._done = true;
    if (!window.ResizeObserver || !els.sheetList) return;
    var debounceTimer = null;
    listReviewDensityRo = new ResizeObserver(function () {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(syncAllListReviewCardDensities, 50);
    });
    listReviewDensityRo.observe(els.sheetList);
  }

  function cartListSignature(items) {
    return (
      (state.systemFilter || 'ALL') +
      '|' +
      items
        .map(function (i) {
          var ry = releaseYearFromItem(i);
          return [
            i.ui_id,
            i.selected,
            i.isGoodCondition ? '1' : '0',
            i.title || '',
            i.pcid || '',
            ry != null ? String(ry) : '',
            getLooseConditionLabel(i.system),
            itemIsHotlist(i) ? '1' : '0',
          ].join(':');
        })
        .join(';') +
      '|lr1'
    );
  }

  function renderLists() {
    var items = visibleCart();
    var peekHost = document.getElementById('tqSheetPeekList');
    var usePeekFirst = false;
    var sig = cartListSignature(items);
    var prevSig = els.sheetList ? els.sheetList.dataset.tqListSig : '';
    var domCount = els.sheetList ? els.sheetList.querySelectorAll('.tq-game-card').length : 0;
    var needFullRebuild = !prevSig || prevSig !== sig || domCount !== items.length;

    if (needFullRebuild && els.sheetList) {
      els.sheetList.innerHTML = '';
      items.forEach(function (item) {
        els.sheetList.appendChild(buildGameCard(item, { listReview: true }));
      });
      els.sheetList.dataset.tqListSig = sig;
      requestAnimationFrame(function () {
        requestAnimationFrame(syncAllListReviewCardDensities);
      });
    }

    if (peekHost) {
      if (usePeekFirst) {
        peekHost.hidden = false;
        var first = items[0];
        var firstId = first && first.ui_id;
        var peekSig =
          (firstId || '') +
          ':' +
          (first && first.selected ? first.selected : '') +
          ':' +
          (first && first.isGoodCondition ? '1' : '0') +
          ':' +
          (first && itemIsHotlist(first) ? '1' : '0');
        var peekStale =
          !peekHost.firstChild ||
          peekHost.dataset.tqPeekFirstId !== firstId ||
          peekHost.dataset.tqPeekSig !== peekSig;
        if (needFullRebuild || peekStale) {
          peekHost.innerHTML = '';
          peekHost.appendChild(buildGameCard(first, { peekStrip: true }));
          peekHost.dataset.tqPeekFirstId = firstId || '';
          peekHost.dataset.tqPeekSig = peekSig;
        }
      } else {
        peekHost.hidden = true;
        peekHost.innerHTML = '';
        peekHost.removeAttribute('data-tq-peek-first-id');
        peekHost.removeAttribute('data-tq-peek-sig');
      }
    }
  }

  function mailCartLinesForApi() {
    return state.cart
      .filter(function (i) {
        return !isStorefrontTradeScoreOrCatalogBlocked(i) && !needsInPersonCashOffer(i);
      })
      .map(function (i) {
        return { pcid: i.pcid, selected: i.selected, tlc: true };
      });
  }

  /** Same line filter as mail / legacy V1 QR; selected normalized for in-store quote API. Includes quoted cash/credit (TLC rules) for funnel analytics. */
  function inStoreCartLinesForApi() {
    var out = [];
    state.cart.forEach(function (i) {
      if (isStorefrontTradeScoreOrCatalogBlocked(i)) return;
      if (needsInPersonCashOffer(i)) return;
      var pcid = i.pcid != null && String(i.pcid).trim() !== '' ? String(i.pcid).trim() : '';
      if (!pcid) return;
      var sel = i.selected === 'inbox' ? 'inbox' : i.selected === 'cib' ? 'cib' : 'loose';
      var p = linePrices(i);
      out.push({ pcid: pcid, selected: sel, cash: p.cash, credit: p.credit });
    });
    return out;
  }

  function mailCashOfferTotal() {
    return cartTotals().cash;
  }

  function mailCreditOfferTotal() {
    return cartTotals().credit;
  }

  /** Which physical media types appear in the mail-in quote (same line filter as API). */
  function mailQuoteInventoryMediaFlags() {
    var hasDisc = false;
    var hasCartridge = false;
    state.cart.forEach(function (i) {
      if (isStorefrontTradeScoreOrCatalogBlocked(i) || needsInPersonCashOffer(i)) return;
      if (isCartridgeSystem(i.system)) hasCartridge = true;
      else hasDisc = true;
    });
    return { hasDisc: hasDisc, hasCartridge: hasCartridge };
  }

  function mailFlowProgressHtml(stepKey) {
    var n = stepKey === 'quality' ? 1 : stepKey === 'address' ? 2 : stepKey === 'payment' ? 3 : 0;
    var name =
      stepKey === 'quality'
        ? 'Condition policy'
        : stepKey === 'address'
          ? 'Address'
          : stepKey === 'payment'
            ? 'Payment'
            : '';
    if (!n) return '';
    return (
      '<nav class="tq-mail-progress" aria-label="Mail-in progress">' +
      '<span class="tq-mail-progress__step">Step ' +
      n +
      ' of 3</span>' +
      '<span class="tq-mail-progress__name" aria-current="step">' +
      escapeHtml(name) +
      '</span>' +
      '</nav>'
    );
  }

  function mailQualityDealbreakersHtml() {
    var flags = mailQuoteInventoryMediaFlags();
    var discLines = [
      'Cracked discs',
      'Disc rot',
      'Scratches on the top of the disc',
      'Water damaged / torn box art',
    ];
    var cartLines = [
      'Corroded / rusty pins',
      'Ripped / missing labels',
      'Cracked / damaged shells',
      'Boxes with moderate wear or water damage',
    ];
    function checklist(items) {
      return (
        '<ul class="tq-quality-checklist" role="list">' +
        items
          .map(function (t) {
            return (
              '<li><span class="tq-quality-x" aria-hidden="true">❌</span> <span>' + escapeHtml(t) + '</span></li>'
            );
          })
          .join('') +
        '</ul>'
      );
    }
    var inner = '';
    if (flags.hasDisc && flags.hasCartridge) {
      inner =
        '<div class="tq-quality-section">' +
        '<p class="tq-quality-section__label">Disc disqualifiers</p>' +
        checklist(discLines) +
        '</div>' +
        '<div class="tq-quality-section">' +
        '<p class="tq-quality-section__label">Cartridge disqualifiers</p>' +
        checklist(cartLines) +
        '</div>';
    } else if (flags.hasCartridge && !flags.hasDisc) {
      inner = checklist(cartLines);
    } else {
      inner = checklist(discLines);
    }
    return (
      '<div class="tq-quality-unacceptable">' +
      '<h3 class="tq-quality-unacceptable__title">Unacceptable conditions</h3>' +
      inner +
      '</div>'
    );
  }

  function mailInAddressIsBlocked(stateRaw, cityRaw, line1Raw) {
    var state = (stateRaw || '').trim().toUpperCase();
    if (MAIL_IN_BLOCKED_STATES[state]) return true;
    var c = (cityRaw || '').toUpperCase();
    var l = (line1Raw || '').toUpperCase();
    if (/\b(APO|FPO|DPO)\b/.test(c) || /\b(APO|FPO|DPO)\b/.test(l)) return true;
    return false;
  }

  function mailLabelFallbackHtml(tracking) {
    var t = escapeHtml((tracking || '').trim());
    return (
      '<div class="tq-mail-tracking-fallback" role="status">' +
      '<p class="tq-mail-tracking-fallback__line">Your tracking number is <strong class="tq-mail-tracking-fallback__code">' +
      t +
      '</strong>.</p>' +
      '<p class="tq-mail-tracking-fallback__hint">Please check your email for the printable label, or log into your account to print it.</p>' +
      '</div>'
    );
  }

  function mailLabelUrlLooksPdf(url) {
    var u = (url || '').trim().toLowerCase();
    if (!u) return false;
    return u.indexOf('.pdf') !== -1;
  }

  function mountMailSuccessLabel(host, res) {
    if (!host) return;
    var url = ((res && (res.labelQrUrl || res.labelUrl)) || '').trim();
    var tn = (res && res.trackingNumber) || '';
    if (!url) {
      host.innerHTML = mailLabelFallbackHtml(tn);
      return;
    }
    if (mailLabelUrlLooksPdf(url)) {
      host.innerHTML =
        '<iframe class="tq-usps-label-iframe" src="' +
        escapeHtml(url) +
        '" title="USPS shipping label"></iframe>';
      return;
    }
    host.innerHTML =
      '<div class="tq-mail-label-skeleton" aria-busy="true" aria-label="Loading shipping QR code"><div class="tq-mail-label-skeleton__pulse"></div></div>';
    var skel = host.querySelector('.tq-mail-label-skeleton');
    var img = document.createElement('img');
    img.className = 'tq-usps-broker-qr-img';
    img.alt = 'USPS Label Broker — show this QR at the Post Office';
    img.loading = 'eager';
    img.src = url;
    function removeSkel() {
      if (skel && skel.parentNode) skel.parentNode.removeChild(skel);
    }
    img.onload = removeSkel;
    img.onerror = function () {
      removeSkel();
      host.innerHTML = mailLabelFallbackHtml(tn);
      var trkP = document.querySelector('#tqMailSuccessRoot .tq-mail-success-tracking');
      if (trkP) trkP.hidden = true;
    };
    host.appendChild(img);
  }

  function mailShippingBannerHtml() {
    var total = mailCashOfferTotal();
    var free = total >= MAIL_FREE_SHIPPING_MIN;
    if (free) {
      return '<div class="tq-mail-banner tq-mail-banner--free" role="status">🎉 Your trade qualifies for a FREE prepaid shipping label!</div>';
    }
    return (
      '<div class="tq-mail-banner tq-mail-banner--fee" role="status">Since your trade is under $100, a $7.99 shipping fee will be deducted from your total offer.</div>'
    );
  }

  function mailTotalsRowHtml() {
    var cashTotal = mailCashOfferTotal();
    var creditTotal = mailCreditOfferTotal();
    var free = cashTotal >= MAIL_FREE_SHIPPING_MIN;
    var estCash = free ? cashTotal : Math.max(0, cashTotal - MAIL_SHIPPING_FEE);
    var estCredit = free ? creditTotal : Math.max(0, creditTotal - MAIL_SHIPPING_FEE);
    var feeLine =
      '<div class="tq-mail-total-card__stack">' +
      '<div class="tq-mail-total-card__line"><span>Subtotal</span><span>' +
      formatMoneyPlain(cashTotal) +
      '</span></div>' +
      '<div class="tq-mail-total-card__line tq-mail-total-card__line--fee"><span>Shipping label</span><span>−' +
      formatMoneyPlain(MAIL_SHIPPING_FEE) +
      '</span></div>' +
      '<div class="tq-mail-total-card__line tq-mail-total-card__line--payout"><span>Estimated payout</span><span>' +
      formatMoneyPlain(estCash) +
      '</span></div>' +
      '</div>';
    var cashSub = free
      ? '<div class="tq-mail-total-card__sub"><strong>Est. cash after shipping</strong> ' +
        formatMoneyPlain(estCash) +
        ' <span style="font-weight:800;color:#063">· FREE label</span></div>'
      : '<div class="tq-mail-total-card__sub tq-mail-total-card__sub--stacked">' + feeLine + '</div>';
    var creditFeeLine =
      '<div class="tq-mail-total-card__stack">' +
      '<div class="tq-mail-total-card__line"><span>Subtotal</span><span>' +
      formatMoneyPlain(creditTotal) +
      '</span></div>' +
      '<div class="tq-mail-total-card__line tq-mail-total-card__line--fee"><span>Shipping label</span><span>−' +
      formatMoneyPlain(MAIL_SHIPPING_FEE) +
      '</span></div>' +
      '<div class="tq-mail-total-card__line tq-mail-total-card__line--payout"><span>Estimated payout</span><span>' +
      formatMoneyPlain(estCredit) +
      '</span></div>' +
      '</div>';
    var creditSub = free
      ? '<div class="tq-mail-total-card__sub"><strong>Est. credit after shipping</strong> ' +
        formatMoneyPlain(estCredit) +
        ' <span style="font-weight:800;color:#063">· FREE label</span></div>'
      : '<div class="tq-mail-total-card__sub tq-mail-total-card__sub--stacked">' + creditFeeLine + '</div>';
    return (
      '<div class="tq-mail-totals-wrap">' +
      '<div class="tq-mail-totals-grid">' +
      '<div class="tq-mail-total-card tq-mail-total-card--cash">' +
      '<span class="tq-mail-total-card__label">Total cash offer</span>' +
      '<span class="tq-mail-total-card__value">' +
      formatMoneyPlain(cashTotal) +
      '</span>' +
      cashSub +
      '</div>' +
      '<div class="tq-mail-total-card tq-mail-total-card--credit">' +
      '<span class="tq-mail-total-card__label">Total store credit</span>' +
      '<span class="tq-mail-total-card__value">' +
      formatMoneyPlain(creditTotal) +
      '</span>' +
      creditSub +
      '</div>' +
      '</div></div>'
    );
  }

  function mailPayLabels(method) {
    if (method === 'paypal') return { a: 'PayPal email' };
    if (method === 'zelle') return { a: 'Zelle email or phone' };
    if (method === 'store_credit') return { a: 'Email for store credit' };
    return { a: 'Venmo username' };
  }

  var mailEncryptFitObs = null;
  function disconnectMailEncryptFit() {
    if (mailEncryptFitObs) {
      mailEncryptFitObs.disconnect();
      mailEncryptFitObs = null;
    }
  }
  function runMailEncryptFit() {
    var wrap = document.getElementById('tqPayEncryptWrap');
    var note = document.getElementById('tqPayEncryptNote');
    if (!wrap || !note) return;
    note.style.transform = '';
    var maxW = wrap.getBoundingClientRect().width;
    if (maxW < 40) return;
    var w = note.scrollWidth;
    if (!w || w <= maxW) return;
    var s = Math.max(0.62, Math.min(1, maxW / w));
    note.style.transformOrigin = 'left center';
    note.style.transform = 'scale(' + s + ')';
  }
  function attachMailEncryptFit() {
    disconnectMailEncryptFit();
    var wrap = document.getElementById('tqPayEncryptWrap');
    if (!wrap) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(runMailEncryptFit);
    });
    if (typeof ResizeObserver !== 'undefined') {
      mailEncryptFitObs = new ResizeObserver(runMailEncryptFit);
      mailEncryptFitObs.observe(wrap);
    }
  }

  function bindMailPaySeg() {
    var payStep = document.getElementById('tqCheckoutStepPayment');
    if (!payStep) return;
    var seg = payStep.querySelector('.tq-pay-seg');
    if (!seg) return;
    function applyLabels(method) {
      var lab = mailPayLabels(method);
      var la = document.getElementById('tqPayLabelA');
      if (la) la.textContent = lab.a;
      var pri = document.getElementById('tqPayPrimary');
      if (pri) {
        pri.placeholder =
          method === 'paypal' || method === 'store_credit'
            ? 'you@email.com'
            : method === 'zelle'
              ? 'Email or mobile'
              : '@username or phone';
        pri.type = method === 'paypal' || method === 'store_credit' ? 'email' : 'text';
      }
      var pcf = document.getElementById('tqPayPrimaryConfirm');
      if (pcf && pri) {
        pcf.placeholder = pri.placeholder;
        pcf.type = pri.type;
      }
    }
    function selectMethod(method) {
      seg.querySelectorAll('[data-pay]').forEach(function (b) {
        b.classList.toggle('is-selected', b.getAttribute('data-pay') === method);
      });
      applyLabels(method);
    }
    if (!seg._tqMailPaySegBound) {
      seg._tqMailPaySegBound = true;
      seg.querySelectorAll('[data-pay]').forEach(function (b) {
        b.addEventListener('click', function () {
          hapticLight();
          var m = b.getAttribute('data-pay') || 'venmo';
          selectMethod(m);
          var priR = document.getElementById('tqPayPrimary');
          if (priR) priR.dispatchEvent(new Event('input', { bubbles: true }));
          var pcfR = document.getElementById('tqPayPrimaryConfirm');
          if (pcfR) pcfR.dispatchEvent(new Event('input', { bubbles: true }));
          requestAnimationFrame(runMailEncryptFit);
        });
      });
    }
    selectMethod(state.mailPaymentMethod || 'paypal');
  }

  /** Enables “Lock in trade” when payment fields match (and valid email for store credit). */
  function bindMailPaySubmitGate() {
    var btn = document.getElementById('tqMailSubmit');
    var pri = document.getElementById('tqPayPrimary');
    var pcf = document.getElementById('tqPayPrimaryConfirm');
    function selectedPayMethod() {
      var payStep = document.getElementById('tqCheckoutStepPayment');
      var sel = payStep && payStep.querySelector('.tq-pay-seg .is-selected');
      return (sel && sel.getAttribute('data-pay')) || '';
    }
    function sync() {
      if (!btn || !pri || !pcf) return;
      var a = (pri.value || '').trim();
      var b = (pcf.value || '').trim();
      var mismatch = a.length > 0 && b.length > 0 && a !== b;
      var pe = document.getElementById('tqPayErr');
      if (mismatch) {
        if (pe) {
          pe.textContent = 'Payment details do not match.';
          pe.hidden = false;
        }
      } else if (pe && pe.textContent === 'Payment details do not match.') {
        pe.textContent = '';
        pe.hidden = true;
      }
      var matchOk = a.length > 0 && b.length > 0 && a === b;
      var ok = matchOk;
      if (ok && selectedPayMethod() === 'store_credit') {
        var em = a.toLowerCase();
        var at = em.indexOf('@');
        ok = at > 0 && em.lastIndexOf('.') > at && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em);
      }
      btn.disabled = !ok || !!state.mailSubmitPending;
    }
    sync();
    if (!bindMailPaySubmitGate._wired && pri && pcf) {
      bindMailPaySubmitGate._wired = true;
      pri.addEventListener('input', sync);
      pri.addEventListener('change', sync);
      pcf.addEventListener('input', sync);
      pcf.addEventListener('change', sync);
    }
  }

  function goMailStep(step) {
    withViewTransition(function () {
      setState({ mailFlowStep: step });
    });
  }

  async function submitMailInTrade() {
    if (!state.mailQualityAcknowledged) {
      showToast(
        'Go back to the condition step and confirm you understand inspection, payouts, and return shipping for rejected items.',
        TQ_TOAST_ERROR_MS
      );
      return;
    }

    var addr = state.mailAddressSnapshot;
    if (!addr || !addr.name || !addr.line1 || !addr.city || !addr.state || !addr.zip || !addr.email) {
      showToast('Address missing — go back to the address step.', TQ_TOAST_ERROR_MS);
      return;
    }
    var detail = (state.mailPaymentDetail || '').trim();
    if (!detail) {
      showToast('Payment details missing — go back to payment.', TQ_TOAST_ERROR_MS);
      return;
    }
    var lines = mailCartLinesForApi();
    if (!lines.length) {
      showToast('Nothing to ship in this quote.', TQ_TOAST_ERROR_MS);
      return;
    }

    setState({ mailSubmitPending: true });
    render();
    try {
      var mailPayload = {
        address: addr,
        cart: lines,
        paymentMethod: state.mailPaymentMethod || 'paypal',
        paymentDetails: detail,
        qualityAcknowledged: true,
      };
      if (_s.storefrontQuoteId) mailPayload.storefrontQuoteId = _s.storefrontQuoteId;
      var res = await fetch(TRADE_MAIL_IN_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(mailPayload),
      });
      var bodyText = '';
      try {
        bodyText = await res.text();
      } catch (e) {
        bodyText = '';
      }
      var data = {};
      try {
        data = bodyText ? JSON.parse(bodyText) : {};
      } catch (e) {
        data = {};
      }
      if (!res.ok) {
        console.error('[mail-in] response not ok', res.status, bodyText);
        var serverErr =
          ((typeof data.error === 'string' && data.error.trim()) ||
            (typeof data.message === 'string' && data.message.trim()) ||
            '');
        /* Prefer server-safe copy for 4xx and 5xx (e.g. label provider failures return 503). */
        var errMsg = serverErr || TRADE_MAIL_IN_CONSUMER_FALLBACK;
        throw new Error(errMsg);
      }
      setState({
        mailSubmitPending: false,
        mailFlowStep: 'success',
        mailSubmitResult: {
          tradeId: data.tradeId,
          trackingNumber: data.trackingNumber,
          labelQrUrl: data.labelQrUrl || data.labelUrl || '',
          priceLockedUntil: typeof data.priceLockedUntil === 'string' ? data.priceLockedUntil : '',
          cashOfferTotal: typeof data.cashOfferTotal === 'number' ? data.cashOfferTotal : null,
          estimatedPayoutAfterShipping:
            typeof data.estimatedPayoutAfterShipping === 'number'
              ? data.estimatedPayoutAfterShipping
              : null,
          tradeOfferTotal: typeof data.tradeOfferTotal === 'number' ? data.tradeOfferTotal : null,
          estimatedTradeCreditAfterShipping:
            typeof data.estimatedTradeCreditAfterShipping === 'number'
              ? data.estimatedTradeCreditAfterShipping
              : null,
        },
      });
      render();
    } catch (e) {
      console.error('[mail-in] submit', e);
      setState({ mailSubmitPending: false });
      render();
      var msg = TRADE_MAIL_IN_CONSUMER_FALLBACK;
      if (e instanceof Error && e.message && !/failed to fetch|networkerror|load failed|network request failed/i.test(e.message)) {
        msg = e.message;
      }
      showToast(msg, TQ_TOAST_ERROR_MS);
    }
  }

  function getCheckoutStepEls() {
    return {
      pick: document.getElementById('tqCheckoutStepPick'),
      local: document.getElementById('tqCheckoutStepLocal'),
      quality: document.getElementById('tqCheckoutStepQuality'),
      address: document.getElementById('tqCheckoutStepAddress'),
      payment: document.getElementById('tqCheckoutStepPayment'),
      success: document.getElementById('tqCheckoutStepSuccess'),
    };
  }

  function hideAllCheckoutSteps(steps) {
    if (!steps) steps = getCheckoutStepEls();
    ['pick', 'local', 'quality', 'address', 'payment', 'success'].forEach(function (k) {
      if (steps[k]) steps[k].hidden = true;
    });
  }

  function fillMailFlowSlots(stepEl, stepKey) {
    if (!stepEl) return;
    var ban = stepEl.querySelector('[data-tq-mail-slot="banner"]');
    var tot = stepEl.querySelector('[data-tq-mail-slot="totals"]');
    if (stepKey === 'payment') {
      if (ban) ban.innerHTML = mailShippingBannerHtml();
      if (tot) tot.innerHTML = mailTotalsRowHtml();
    } else {
      if (ban) ban.innerHTML = '';
      if (tot) tot.innerHTML = '';
    }
  }

  /** Hide sheet peek money row during mail-in until payment (banner + totals only on payment step). */
  function syncMailCheckoutPeekTotalsRow() {
    var row = document.querySelector('#tqSheetPeek .tq-sheet-peek-row');
    if (!row) return;
    var mail = state.checkoutStep === 'mail';
    var step = state.mailFlowStep || 'quality';
    var showMoneyStrip = !mail || step === 'payment';
    row.hidden = !showMoneyStrip;
  }

  function isMailSuccessCheckout() {
    return (
      state.checkoutStep === 'mail' &&
      (state.mailFlowStep || '') === 'success' &&
      !!state.mailSubmitResult
    );
  }

  function syncMailHeaderProgress() {
    var hp = document.getElementById('tqMailHeaderProgress');
    if (!hp) return;
    if (state.checkoutStep === 'mail') {
      var st = state.mailFlowStep || 'quality';
      if (st === 'quality' || st === 'address' || st === 'payment') {
        hp.innerHTML = mailFlowProgressHtml(st);
        hp.hidden = false;
        return;
      }
    }
    hp.innerHTML = '';
    hp.hidden = true;
  }

  function applyCheckoutModalChrome() {
    if (!els.checkout) return;
    if (root) {
      if (state.checkoutStep) {
        root.setAttribute('data-checkout-open', 'true');
      } else {
        root.removeAttribute('data-checkout-open');
      }
    }
    var head = document.getElementById('tqCheckoutHead');
    var mailSuccess = isMailSuccessCheckout();
    if (!state.checkoutStep) {
      els.checkout.classList.remove('tq-checkout--mail-fullscreen', 'tq-checkout--mail-success');
      if (head) {
        head.hidden = false;
        head.classList.remove('tq-checkout-head--mail-flow', 'tq-checkout-head--mail-success');
      }
      syncMailHeaderProgress();
      return;
    }
    els.checkout.classList.toggle('tq-checkout--mail-fullscreen', state.checkoutStep === 'mail');
    els.checkout.classList.toggle('tq-checkout--mail-success', !!mailSuccess);
    if (head) {
      head.hidden = false;
      head.classList.toggle('tq-checkout-head--mail-success', !!mailSuccess);
      var mailFlowHead =
        state.checkoutStep === 'mail' &&
        !mailSuccess &&
        ['quality', 'address', 'payment'].indexOf(state.mailFlowStep || 'quality') !== -1;
      head.classList.toggle('tq-checkout-head--mail-flow', !!mailFlowHead);
    }
    syncMailHeaderProgress();
  }

  function clearMailAddrErr() {
    var ae = document.getElementById('tqMailAddrErr');
    if (ae) {
      ae.textContent = '';
      ae.hidden = true;
    }
  }

  function wireMailAddressFieldErrClearOnce() {
    if (wireMailAddressFieldErrClearOnce._done) return;
    wireMailAddressFieldErrClearOnce._done = true;
    ['tqMailName', 'tqMailLine1', 'tqMailCity', 'tqMailState', 'tqMailZip', 'tqMailEmail'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) {
        el.addEventListener('input', clearMailAddrErr);
        el.addEventListener('change', clearMailAddrErr);
      }
    });
  }

  function handleMailAddressContinueClick() {
    var name = ((document.getElementById('tqMailName') || {}).value || '').trim();
    var line1 = ((document.getElementById('tqMailLine1') || {}).value || '').trim();
    var city = ((document.getElementById('tqMailCity') || {}).value || '').trim();
    var st = ((document.getElementById('tqMailState') || {}).value || '').trim();
    var zip = ((document.getElementById('tqMailZip') || {}).value || '').trim();
    var email = ((document.getElementById('tqMailEmail') || {}).value || '').trim();
    clearMailAddrErr();
    if (!name || !line1 || !city || !st || !zip || !email) {
      showToast('Fill in every address field.', TQ_TOAST_ERROR_MS);
      return;
    }
    if (email.indexOf('@') === -1) {
      showToast('Enter a valid email.', TQ_TOAST_ERROR_MS);
      return;
    }
    if (!/^\d{5}(?:[-\s]\d{4})?$/.test(zip)) {
      var aeZip = document.getElementById('tqMailAddrErr');
      if (aeZip) {
        aeZip.textContent = 'Please enter a valid 5-digit ZIP code.';
        aeZip.hidden = false;
      }
      showToast('Please enter a valid 5-digit ZIP code.', TQ_TOAST_ERROR_MS);
      return;
    }
    if (mailInAddressIsBlocked(st, city, line1)) {
      var ae = document.getElementById('tqMailAddrErr');
      if (ae) {
        ae.textContent = MAIL_IN_CONTIGUOUS_US_MSG;
        ae.hidden = false;
      }
      showToast(MAIL_IN_CONTIGUOUS_US_MSG, TQ_TOAST_ERROR_MS);
      return;
    }
    hapticLight();
    setState({
      mailAddressSnapshot: { name: name, line1: line1, city: city, state: st, zip: zip, email: email },
      mailFlowStep: 'payment',
    });
  }

  function handleMailPaymentSubmitClick() {
    var payStep = document.getElementById('tqCheckoutStepPayment');
    var sel = payStep && payStep.querySelector('.tq-pay-seg .is-selected');
    var method = (sel && sel.getAttribute('data-pay')) || 'paypal';
    var a = ((document.getElementById('tqPayPrimary') || {}).value || '').trim();
    var b = ((document.getElementById('tqPayPrimaryConfirm') || {}).value || '').trim();
    var pe = document.getElementById('tqPayErr');
    if (pe) pe.hidden = true;
    if (!a || !b) {
      if (pe) {
        pe.textContent = 'Enter your payment details.';
        pe.hidden = false;
      }
      showToast('Enter your payment details.', TQ_TOAST_ERROR_MS);
      return;
    }
    if (a !== b) {
      if (pe) {
        pe.textContent = 'Payment details do not match.';
        pe.hidden = false;
      }
      showToast('Payment details do not match.', TQ_TOAST_ERROR_MS);
      return;
    }
    if (method === 'store_credit') {
      var em = a.toLowerCase();
      var at = em.indexOf('@');
      var okEm = at > 0 && em.lastIndexOf('.') > at && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em);
      if (!okEm) {
        if (pe) {
          pe.textContent = 'Enter a valid email for store credit.';
          pe.hidden = false;
        }
        showToast('Enter a valid email for store credit.', TQ_TOAST_ERROR_MS);
        return;
      }
    }
    hapticLight();
    setState({ mailPaymentMethod: method, mailPaymentDetail: a });
    submitMailInTrade();
  }

  function mountCheckoutBodyDelegation() {
    if (mountCheckoutBodyDelegation._done) return;
    mountCheckoutBodyDelegation._done = true;
    var body = els.checkoutBody;
    if (!body) return;
    body.addEventListener('change', function (e) {
      if (e.target && e.target.id === 'tqQualityAck') {
        var cont = document.getElementById('tqMailQualityContinue');
        if (cont) cont.disabled = !e.target.checked;
        setState({ mailQualityAcknowledged: !!e.target.checked });
      }
    });
    body.addEventListener('click', function (e) {
      if (e.target.closest('#tqCheckoutStepPick [data-trade]')) {
        var pickBtn = e.target.closest('[data-trade]');
        if (!pickBtn) return;
        hapticLight();
        var t = pickBtn.getAttribute('data-trade');
        if (t === 'mail') {
          setState({
            tradeType: t,
            checkoutStep: 'mail',
            mailFlowStep: 'quality',
            mailSubmitResult: null,
            mailSubmitPending: false,
            mailAddressSnapshot: null,
            mailPaymentMethod: 'paypal',
            mailPaymentDetail: '',
            mailQualityAcknowledged: false,
          });
        } else if (t === 'local') {
          setState({ tradeType: t, checkoutStep: 'local' });
        }
        return;
      }
      if (e.target.closest('#tqCheckoutStepLocal [data-done]')) {
        setState({ checkoutStep: null });
        return;
      }
      if (e.target.closest('[data-mail-exit]')) {
        setState({
          checkoutStep: null,
          tradeType: null,
          mailFlowStep: 'quality',
          mailSubmitResult: null,
          mailSubmitPending: false,
          mailAddressSnapshot: null,
          mailPaymentMethod: 'paypal',
          mailPaymentDetail: '',
          mailQualityAcknowledged: false,
        });
        return;
      }
      if (e.target.closest('#tqMailQualityContinue')) {
        var ack = document.getElementById('tqQualityAck');
        var qerr = document.getElementById('tqQualityErr');
        if (qerr) qerr.hidden = true;
        if (!ack || !ack.checked) {
          if (qerr) {
            qerr.textContent =
              'Check the box to confirm you understand inspection, payouts, and return shipping for rejected items.';
            qerr.hidden = false;
          }
          showToast(
            'Check the box to confirm you understand inspection, payouts, and return shipping for rejected items.',
            TQ_TOAST_ERROR_MS
          );
          return;
        }
        hapticLight();
        setState({ mailQualityAcknowledged: true });
        goMailStep('address');
        return;
      }
      if (e.target.closest('[data-mail-back-quality]')) {
        hapticLight();
        goMailStep('quality');
        return;
      }
      if (e.target.closest('#tqMailToPayment')) {
        handleMailAddressContinueClick();
        return;
      }
      if (e.target.closest('[data-mail-back-addr]')) {
        hapticLight();
        goMailStep('address');
        return;
      }
      if (e.target.closest('[data-mail-edit-quote]')) {
        hapticLight();
        setState({ checkoutStep: null });
        return;
      }
      if (e.target.closest('#tqMailSubmit')) {
        handleMailPaymentSubmitClick();
        return;
      }
    });
  }

  function computeMailSuccessPriceLockStr(res) {
    var priceLockDateStr = '';
    var lockFromApi = ((res && res.priceLockedUntil) || '').trim();
    if (lockFromApi) {
      var lockParsed = new Date(lockFromApi);
      if (!isNaN(lockParsed.getTime())) {
        priceLockDateStr = lockParsed.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        });
      }
    }
    if (!priceLockDateStr) {
      var lockFallback = new Date();
      lockFallback.setDate(lockFallback.getDate() + 10);
      priceLockDateStr = lockFallback.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      });
    }
    return priceLockDateStr;
  }

  function renderCheckout() {
    var steps = getCheckoutStepEls();
    if (!state.checkoutStep) {
      if (tqCheckoutScrollLockHeld) {
        unlockPageScroll();
        tqCheckoutScrollLockHeld = false;
      }
      disconnectMailEncryptFit();
      els.checkout.hidden = true;
      hideAllCheckoutSteps(steps);
      tqWasShowingLocalCheckout = false;
      applyCheckoutModalChrome();
      var flashReset = document.getElementById('tqCameraFlash');
      if (flashReset) flashReset.style.removeProperty('opacity');
      return;
    }
    if (!tqCheckoutScrollLockHeld) {
      lockPageScroll();
      tqCheckoutScrollLockHeld = true;
    }
    els.checkout.hidden = false;
    hideAllCheckoutSteps(steps);
    if (state.checkoutStep !== 'local') {
      tqWasShowingLocalCheckout = false;
    }

    if (state.checkoutStep === 'pick') {
      els.checkoutTitle.textContent = 'How will you get your games to us?';
      steps.pick.hidden = false;
      applyCheckoutModalChrome();
      return;
    }
    if (state.checkoutStep === 'local') {
      els.checkoutTitle.textContent = 'Your Store Pass';
      steps.local.hidden = false;
      if (!tqWasShowingLocalCheckout) {
        _s.inStoreQrFailedSig = '';
        _s.inStoreQrError = '';
      }
      tqWasShowingLocalCheckout = true;
      refreshLocalCheckoutQr();
      applyCheckoutModalChrome();
      return;
    }
    if (state.checkoutStep === 'mail') {
      disconnectMailEncryptFit();
      var step = state.mailFlowStep || 'quality';
      if (step === 'success' && !state.mailSubmitResult) {
        step = 'quality';
      }

      if (step === 'success' && state.mailSubmitResult) {
        var res = state.mailSubmitResult;
        els.checkoutTitle.textContent = 'Locked in';
        steps.success.hidden = false;
        var tidEl = document.getElementById('tqMailSuccessTradeId');
        if (tidEl) tidEl.textContent = (res.tradeId || '').trim();
        var lockEl = document.getElementById('tqMailSuccessLockDate');
        if (lockEl) lockEl.textContent = computeMailSuccessPriceLockStr(res);
        var mediaHost = document.getElementById('tqMailLabelMediaHost');
        if (mediaHost) mediaHost.innerHTML = '';
        mountMailSuccessLabel(mediaHost, res);
        var trkP = document.querySelector('#tqMailSuccessRoot .tq-mail-success-tracking');
        var trkStrong = document.getElementById('tqMailSuccessTracking');
        var hasLabelUrl = !!((res.labelQrUrl || res.labelUrl || '').trim());
        var showingFallback = mediaHost && mediaHost.querySelector('.tq-mail-tracking-fallback');
        if (res.trackingNumber && trkP && trkStrong && hasLabelUrl && !showingFallback) {
          trkStrong.textContent = res.trackingNumber;
          trkP.hidden = false;
        } else if (trkP) {
          trkP.hidden = true;
        }
        applyCheckoutModalChrome();
        return;
      }

      if (step === 'quality') {
        els.checkoutTitle.textContent = 'Mail-in · Condition policy';
        steps.quality.hidden = false;
        fillMailFlowSlots(steps.quality, 'quality');
        var qHost = document.getElementById('tqMailQualityDealbreakersHost');
        if (qHost) qHost.innerHTML = mailQualityDealbreakersHtml();
        var ackBox = document.getElementById('tqQualityAck');
        var qCont = document.getElementById('tqMailQualityContinue');
        if (ackBox) ackBox.checked = !!state.mailQualityAcknowledged;
        if (qCont) qCont.disabled = !(ackBox && ackBox.checked);
        var qerr = document.getElementById('tqQualityErr');
        if (qerr) qerr.hidden = true;
        applyCheckoutModalChrome();
        return;
      }

      if (step === 'address') {
        els.checkoutTitle.textContent = 'Mail-in · Address';
        steps.address.hidden = false;
        fillMailFlowSlots(steps.address, 'address');
        wireMailAddressFieldErrClearOnce();
        var snap = state.mailAddressSnapshot;
        function setAddrVal(id, v) {
          var el = document.getElementById(id);
          if (el) el.value = v != null ? String(v) : '';
        }
        setAddrVal('tqMailName', snap && snap.name);
        setAddrVal('tqMailLine1', snap && snap.line1);
        setAddrVal('tqMailCity', snap && snap.city);
        setAddrVal('tqMailState', snap && snap.state);
        setAddrVal('tqMailZip', snap && snap.zip);
        setAddrVal('tqMailEmail', snap && snap.email);
        applyCheckoutModalChrome();
        return;
      }

      if (step === 'payment') {
        els.checkoutTitle.textContent = 'Mail-in · Payment';
        steps.payment.hidden = false;
        fillMailFlowSlots(steps.payment, 'payment');
        var pri = document.getElementById('tqPayPrimary');
        var pcf = document.getElementById('tqPayPrimaryConfirm');
        var pd = state.mailPaymentDetail || '';
        if (pri) pri.value = pd;
        if (pcf) pcf.value = pd;
        var curM = state.mailPaymentMethod || 'paypal';
        var paySeg = steps.payment.querySelector('.tq-pay-seg');
        if (paySeg) {
          paySeg.querySelectorAll('[data-pay]').forEach(function (b) {
            b.classList.toggle('is-selected', b.getAttribute('data-pay') === curM);
          });
        }
        bindMailPaySeg();
        bindMailPaySubmitGate();
        var subBtn = document.getElementById('tqMailSubmit');
        if (subBtn) subBtn.textContent = state.mailSubmitPending ? 'Submitting…' : 'Lock in trade & get label';
        attachMailEncryptFit();
        applyCheckoutModalChrome();
        return;
      }
      applyCheckoutModalChrome();
    }
  }

  function mountInStoreQrMessage(mount, text, className) {
    mount.innerHTML = '';
    var msg = document.createElement('p');
    msg.className = className || 'tq-qr-fallback-msg';
    msg.textContent = text;
    mount.appendChild(msg);
  }

  function mountInStoreQrCode(mount, qrPayload) {
    mount.innerHTML = '';
    if (typeof QRCode === 'undefined') {
      mount.textContent = qrPayload;
      return;
    }
    new QRCode(mount, {
      text: qrPayload,
      width: 200,
      height: 200,
      colorDark: '#000',
      colorLight: '#fff',
      correctLevel: QRCode.CorrectLevel.H,
    });
  }

  /**
   * In-store "Store Pass": POST cart lines → server returns quoteId; QR encodes ISQ|{quoteId}.
   * Dashboard Load QR resolves the id to the same line set as the old V1 payload (TLC assumed).
   */
  function refreshLocalCheckoutQr() {
    var mount = document.getElementById('tqQrMount');
    if (!mount) return;

    var lines = inStoreCartLinesForApi();
    var sig = JSON.stringify(lines);

    if (!lines.length) {
      setState({
        inStoreQrSig: '',
        inStoreQrPayload: '',
        inStoreQrPending: false,
        inStoreQrPendingForSig: '',
        inStoreQrError: '',
        inStoreQrFailedSig: '',
      });
      mountInStoreQrMessage(mount, 'Add games to your quote to get a store pass.');
      return;
    }

    if (_s.inStoreQrSig === sig && _s.inStoreQrPayload) {
      mountInStoreQrCode(mount, _s.inStoreQrPayload);
      return;
    }

    if (_s.inStoreQrPending && _s.inStoreQrPendingForSig === sig) {
      mountInStoreQrMessage(mount, 'Creating your store pass…');
      return;
    }

    if (_s.inStoreQrFailedSig === sig && _s.inStoreQrError) {
      mountInStoreQrMessage(mount, _s.inStoreQrError);
      return;
    }

    var myGen = ++inStoreQuoteFetchGen;
    setState({
      inStoreQrPending: true,
      inStoreQrPendingForSig: sig,
      inStoreQrError: '',
      inStoreQrFailedSig: '',
    });
    mountInStoreQrMessage(mount, 'Creating your store pass…');

    var claimBody = { cart: lines, intent: 'claim_in_store' };
    if (_s.storefrontQuoteId) claimBody.quoteId = _s.storefrontQuoteId;
    fetch(TRADE_IN_STORE_QUOTE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(claimBody),
    })
      .then(function (res) {
        return res.text().then(function (bodyText) {
          return { res: res, bodyText: bodyText || '' };
        });
      })
      .then(function (_ref) {
        var res = _ref.res;
        var bodyText = _ref.bodyText;
        if (myGen !== inStoreQuoteFetchGen) return;
        var data = {};
        try {
          data = bodyText ? JSON.parse(bodyText) : {};
        } catch (e) {
          data = {};
        }
        if (!res.ok) {
          var serverErr =
            (typeof data.error === 'string' && data.error.trim()) ||
            (typeof data.message === 'string' && data.message.trim()) ||
            '';
          throw new Error(serverErr || 'Could not create store pass. Try again.');
        }
        var qid = typeof data.quoteId === 'string' ? data.quoteId.trim() : '';
        if (!qid) throw new Error('Invalid server response.');
        var payload = 'ISQ|' + qid;
        try {
          localStorage.setItem(TQ_QUOTE_ID_STORAGE_KEY, qid);
        } catch (e) {}
        setState({
          inStoreQrPending: false,
          inStoreQrSig: sig,
          inStoreQrPayload: payload,
          inStoreQrError: '',
          inStoreQrFailedSig: '',
          storefrontQuoteId: qid,
        });
        mountInStoreQrCode(mount, payload);
      })
      .catch(function (e) {
        if (myGen !== inStoreQuoteFetchGen) return;
        var msg =
          e instanceof Error && e.message
            ? e.message
            : 'Could not create store pass. Check your connection and try again.';
        setState({
          inStoreQrPending: false,
          inStoreQrPendingForSig: '',
          inStoreQrError: msg,
          inStoreQrFailedSig: sig,
        });
        mountInStoreQrMessage(mount, msg);
      });
  }

  function syncHeroDefaultControls() {}

  function render() {
    renderViews();
    renderLists();
    renderCheckout();
    syncMailCheckoutPeekTotalsRow();
    syncHeroDefaultControls();
  }

  subscribe(render);

  var persistCartTimer = null;
  subscribe(function () {
    clearTimeout(persistCartTimer);
    persistCartTimer = setTimeout(function () {
      try {
        if (!state.cart.length) {
          localStorage.removeItem(TQ_CART_STORAGE_KEY);
          localStorage.removeItem(TQ_QUOTE_ID_STORAGE_KEY);
          _s.storefrontQuoteId = '';
        } else {
          localStorage.setItem(TQ_CART_STORAGE_KEY, JSON.stringify(serializeCartForStorage()));
        }
      } catch (e) {}
    }, 120);

    clearTimeout(storefrontQuoteSyncTimer);
    if (inStoreCartLinesForApi().length) {
      storefrontQuoteSyncTimer = setTimeout(function () {
        doStorefrontQuoteSync();
      }, 950);
    }
  });

  function compressImage(file, maxWidth) {
    return new Promise(function (resolve, reject) {
      if (!file || !file.type || !file.type.startsWith('image/')) {
        reject(new Error('Please choose an image file.'));
        return;
      }
      var mw = maxWidth != null ? Number(maxWidth) : 1080;
      if (!isFinite(mw) || mw < 1) mw = 1080;
      if (mw > 1080) mw = 1080;
      var objUrl = URL.createObjectURL(file);
      var img = new Image();
      img.onerror = function () {
        URL.revokeObjectURL(objUrl);
        reject(new Error('Image failed to load.'));
      };
      img.onload = function () {
        try {
          var canvas = document.createElement('canvas');
          var w = img.width;
          var h = img.height;
          if (w > mw) {
            h = Math.max(1, Math.round(h * (mw / w)));
            w = mw;
          }
          canvas.width = Math.round(w);
          canvas.height = Math.round(h);
          var ctx = canvas.getContext('2d');
          if (!ctx) {
            URL.revokeObjectURL(objUrl);
            reject(new Error('Could not process image.'));
            return;
          }
          ctx.drawImage(img, 0, 0, w, h);
          URL.revokeObjectURL(objUrl);
          canvas.toBlob(
            function (blob) {
              if (!blob) reject(new Error('Could not encode image.'));
              else resolve(blob);
            },
            'image/jpeg',
            0.8
          );
        } catch (err) {
          URL.revokeObjectURL(objUrl);
          reject(err instanceof Error ? err : new Error('Could not process image.'));
        }
      };
      img.src = objUrl;
    });
  }

  /** Shopper-facing scan errors — never raw HTML/XML or infra pages. */
  var TQ_SCAN_ERR_TRY_AGAIN =
    "We couldn't read that photo. Wait a moment and try again, or show fewer games in one shot with good lighting. You can also search by title.";
  var TQ_SCAN_ERR_NETWORK = "We couldn't reach the server. Check your connection and try again.";
  var TQ_SCAN_ERR_TOO_LARGE =
    "That photo is too large for us to process. Try a smaller image or fewer games in the frame.";

  function scanBodyLooksLikeMarkup(s) {
    if (!s || typeof s !== 'string') return false;
    var t = s.trim().slice(0, 500);
    return (
      /^\s*</.test(t) ||
      /<\?xml\b/i.test(t) ||
      /<html[\s>]/i.test(t) ||
      /<body[\s>]/i.test(t) ||
      /<!DOCTYPE\b/i.test(t)
    );
  }

  function scanHttpFailureMessage(status) {
    var n = Number(status);
    if (n === 413 || n === 431) return TQ_SCAN_ERR_TOO_LARGE;
    if (n === 502 || n === 503 || n === 504) {
      return 'Our scanner is briefly busy. Please try again in a few seconds.';
    }
    if (n >= 500) return TQ_SCAN_ERR_TRY_AGAIN;
    if (n === 408 || n === 425) return TQ_SCAN_ERR_TRY_AGAIN;
    if (n >= 400) return "We couldn't complete that scan. Try a clearer photo or search by title.";
    return TQ_SCAN_ERR_TRY_AGAIN;
  }

  /** Allow short JSON `error` strings from the API; drop noisy or technical values. */
  function sanitizeScanApiErrorField(msg) {
    var m = msg != null ? String(msg).trim() : '';
    if (!m) return null;
    if (scanBodyLooksLikeMarkup(m)) return null;
    if (m.length > 280) return null;
    if (/^server error:/i.test(m)) return null;
    if (/<[a-z!?\/]/i.test(m)) return null;
    if (/at\s+[\w$.]+\s+\(/i.test(m) && m.length > 80) return null;
    return m;
  }

  /**
   * Image-scan results with these GlobalCatalog genres are ignored (not shown in confirm modal, not counted in Game X of Y).
   * Kept in sync with GENRE_EXCLUDED_FROM_IMAGE_SCAN in src/app/api/trade-calculator/scan/route.ts.
   */
  var TQ_IMAGE_SCAN_SKIP_GENRES = { systems: true, accessories: true, controllers: true };
  function imageScanResultShouldSkipGenre(raw) {
    if (!raw || raw.genre == null) return false;
    var g = String(raw.genre).trim().toLowerCase();
    return !!TQ_IMAGE_SCAN_SKIP_GENRES[g];
  }

  function formatScanErrorForUser(raw) {
    var msg = raw != null && String(raw).trim() ? String(raw).trim() : '';
    if (!msg) return TQ_SCAN_ERR_TRY_AGAIN;
    if (scanBodyLooksLikeMarkup(msg)) return TQ_SCAN_ERR_TRY_AGAIN;
    if (/unexpected token/i.test(msg) && /json/i.test(msg)) return TQ_SCAN_ERR_TRY_AGAIN;
    if (/failed to fetch|networkerror|load failed|network request failed|aborted|timeout/i.test(msg)) {
      return TQ_SCAN_ERR_NETWORK;
    }
    if (/^server error:\s*\d+/i.test(msg)) {
      var m = msg.match(/^server error:\s*(\d+)/i);
      if (m) return scanHttpFailureMessage(m[1]);
      return TQ_SCAN_ERR_TRY_AGAIN;
    }
    if (msg.length > 280) return TQ_SCAN_ERR_TRY_AGAIN;
    if (/<[a-z!?\/]/i.test(msg)) return TQ_SCAN_ERR_TRY_AGAIN;
    return msg;
  }

  /** Expects multipart field `image` (JPEG) — server must accept FormData instead of JSON base64. */
  async function performScanBlob(blob) {
    var fd = new FormData();
    fd.append('image', blob, 'scan.jpg');
    var res;
    try {
      res = await fetch(TRADE_CALC_API_URL, {
        method: 'POST',
        body: fd,
      });
    } catch (netErr) {
      var nmsg = netErr && netErr.message ? String(netErr.message) : '';
      throw new Error(formatScanErrorForUser(nmsg));
    }
    if (res.status === 429) {
      throw new Error("Whoa there! You're scanning too fast. Please wait a moment and try again.");
    }
    var contentType = res.headers.get('content-type') || '';
    var data = null;
    if (contentType.includes('application/json')) {
      try {
        data = await res.json();
      } catch (parseErr) {
        throw new Error(scanHttpFailureMessage(res.status));
      }
    } else {
      await res.text();
      throw new Error(scanHttpFailureMessage(res.status));
    }
    if (res.ok && data && data.found && data.results) return data.results;
    if (!res.ok) {
      if (data && data.error) {
        var safe = sanitizeScanApiErrorField(data.error);
        if (safe) throw new Error(safe);
      }
      throw new Error(scanHttpFailureMessage(res.status));
    }
    throw new Error('Make sure the game cover is well-lit and in focus, or try searching manually.');
  }

  function updateCatchPricesDisplay() {
    if (!catchDraft) return;
    var p = linePrices(catchDraft);
    var el = document.getElementById('tqCatchPrices');
    if (el) {
      el.innerHTML =
        '<div><small>Cash offer</small><span>' + formatMoneyPlain(p.cash) + '</span></div>' +
        '<div><small>Credit offer</small><span>' + formatMoneyPlain(p.credit) + '</span></div>';
    }
  }

  function syncCatchSystemPill() {
    var pill = document.getElementById('tqCatchSystemPill');
    if (!pill || !catchDraft) return;
    var sys = catchDraft.system != null && String(catchDraft.system).trim() ? String(catchDraft.system).trim() : '—';
    pill.textContent = sys;
    pill.setAttribute('style', getSystemStyle(catchDraft.system));
  }

  function applySearchResultToCatch(raw) {
    if (!catchDraft) return;
    var keepId = catchDraft.ui_id;
    var incoming = Object.assign({}, raw);
    if (!incoming.title && incoming.name) incoming.title = incoming.name;
    var shaped = reshapeCatalogHitForCart(incoming);
    var merged = Object.assign({}, catchDraft, shaped);
    if (keepId) merged.ui_id = keepId;
    /* GID and cover must match the picked row, not the prior draft. */
    merged.shopify_gid =
      shaped.shopify_gid != null && String(shaped.shopify_gid).trim() !== ''
        ? String(shaped.shopify_gid).trim()
        : null;
    merged.imgUrl = shaped.imgUrl;
    if (shaped.system != null && String(shaped.system).trim() !== '') {
      merged.system = String(shaped.system).trim();
    }
    var pickTitle =
      incoming.title != null && String(incoming.title).trim() !== ''
        ? String(incoming.title).trim()
        : incoming.name != null && String(incoming.name).trim() !== ''
          ? String(incoming.name).trim()
          : null;
    if (pickTitle != null) {
      merged.title = pickTitle;
      var sys = incoming.system != null ? String(incoming.system).trim() : '';
      if (sys && merged.title.endsWith(' — ' + sys)) {
        merged.title = merged.title.slice(0, merged.title.length - (' — ' + sys).length).trim();
      }
    }
    catchDraft = normalizeItem(merged);
    var pickedPcid = catchDraft.pcid;
    if (pickedPcid && state.cart.some(function (i) { return i.pcid && i.pcid === pickedPcid; })) {
      catchDraft.scanDuplicateInCart = true;
    } else {
      delete catchDraft.scanDuplicateInCart;
    }
    if (catchReviewList.length && catchReviewIndex >= 0 && catchReviewIndex < catchReviewList.length) {
      catchReviewList[catchReviewIndex] = Object.assign({}, catchDraft);
    }
    var title = document.getElementById('tqCatchTitle');
    setCatchProductImage(catchDraft.imgUrl || GENERIC_CART_SVG, { instant: true });
    if (title) {
      var pickFull = catchDraft.title != null ? String(catchDraft.title).trim() : '';
      title.textContent = pickFull;
      title.setAttribute('title', pickFull);
    }
    syncCatchSystemPill();
    syncCatchConditionSegmentUI(catchDraft);
    updateCatchPricesDisplay();
    syncCatchTradeEligibility();
    var titleRow = document.getElementById('tqCatchTitleRow');
    if (titleRow) titleRow.classList.remove('tq-catch-title-row--editing');
    var editBtnPick = document.getElementById('tqCatchEdit');
    if (editBtnPick) editBtnPick.hidden = false;
    preloadCatchAdjacentCoverUrls();
  }

  function runCatchTitleSearch(inputEl, ddEl) {
    if (!inputEl || !ddEl) return;
    var q = normalizeSearchQueryForApi((inputEl.value || '').trim());
    if (!q) {
      ddEl.hidden = true;
      ddEl.innerHTML = '';
      return;
    }
    ddEl.hidden = false;
    positionSearchDropdown(inputEl, ddEl);
    ddEl.innerHTML = '<div class="tq-dd-load">Searching…</div>';
    positionSearchDropdown(inputEl, ddEl);
    fetch(TRADE_CALC_SEARCH_URL + '?q=' + encodeURIComponent(q))
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var results = (data && data.results) ? data.results : [];
        catchTitleSearchResults = results;
        if (!results.length) {
          ddEl.innerHTML = '<div class="tq-dd-empty">No matches. Try another name or system.</div>';
          positionSearchDropdown(inputEl, ddEl);
          return;
        }
        ddEl.innerHTML = results
          .map(function (item, idx) {
            return searchDdRowHtml(item, idx, { forCartAdd: false });
          })
          .join('');
        positionSearchDropdown(inputEl, ddEl);
        ddEl.querySelectorAll('[data-idx]').forEach(function (btn) {
          btn.addEventListener('mousedown', function (e) {
            e.preventDefault();
            catchTitleBlurFromPick = true;
          });
          btn.addEventListener('click', function () {
            var item = catchTitleSearchResults[parseInt(btn.getAttribute('data-idx'), 10)];
            if (!item) return;
            applySearchResultToCatch(item);
            ddEl.hidden = true;
            ddEl.innerHTML = '';
            var inp = document.getElementById('tqCatchTitleEdit');
            var h = document.getElementById('tqCatchTitle');
            if (inp) {
              inp.hidden = true;
              inp.value = '';
            }
            if (h) {
              h.hidden = false;
              h.textContent = catchDraft.title || '';
            }
            var rowPick = document.getElementById('tqCatchTitleRow');
            if (rowPick) rowPick.classList.remove('tq-catch-title-row--editing');
            catchTitleBlurFromPick = false;
            endCatchTitleEditingUI();
          });
        });
      })
      .catch(function () {
        ddEl.innerHTML = '<div class="tq-dd-empty">Search failed.</div>';
        positionSearchDropdown(inputEl, ddEl);
      });
  }

  function endCatchTitleEditingUI() {
    if (root.dataset.catchTitleEditing !== 'true') return;
    root.dataset.catchTitleEditing = 'false';
    if (catchTitleEditPrevSnap != null) {
      state.sheetSnap = catchTitleEditPrevSnap;
      catchTitleEditPrevSnap = null;
      root.dataset.sheetSnap = state.sheetSnap;
      applySheetTransform(false);
      syncSheetGrabberAria();
    }
  }

  function resetCatchTitleEditUI() {
    var row = document.getElementById('tqCatchTitleRow');
    if (row) row.classList.remove('tq-catch-title-row--editing');
    var editBtn = document.getElementById('tqCatchEdit');
    if (editBtn) editBtn.hidden = false;
    var h = document.getElementById('tqCatchTitle');
    var inp = document.getElementById('tqCatchTitleEdit');
    var dd = document.getElementById('tqCatchTitleDropdown');
    if (h) h.style.removeProperty('font-size');
    if (inp) {
      inp.style.removeProperty('font-size');
      inp.hidden = true;
      inp.value = '';
    }
    if (h) h.hidden = false;
    if (dd) {
      dd.hidden = true;
      dd.innerHTML = '';
    }
    endCatchTitleEditingUI();
  }

  function commitCatchTitleEdit() {
    if (!catchDraft) return;
    var row = document.getElementById('tqCatchTitleRow');
    if (row) row.classList.remove('tq-catch-title-row--editing');
    var editBtn = document.getElementById('tqCatchEdit');
    if (editBtn) editBtn.hidden = false;
    var h = document.getElementById('tqCatchTitle');
    var inp = document.getElementById('tqCatchTitleEdit');
    if (!h || !inp) return;
    var v = (inp.value || '').trim();
    if (v) catchDraft.title = v;
    var committed = catchDraft.title != null ? String(catchDraft.title).trim() : '';
    h.style.removeProperty('font-size');
    h.textContent = committed;
    h.setAttribute('title', committed);
    inp.hidden = true;
    h.hidden = false;
    if (catchReviewList.length && catchReviewIndex >= 0 && catchReviewIndex < catchReviewList.length) {
      catchReviewList[catchReviewIndex] = Object.assign({}, catchDraft);
    }
    endCatchTitleEditingUI();
  }

  function setCameraCatchBlur(on) {
    if (els.cameraHost) els.cameraHost.classList.toggle('tq-camera-host--blurred', on);
    var r = root.querySelector('.tq-camera-reticle');
    if (r) r.classList.toggle('tq-camera-host--blurred', on);
  }

  function runCatchImgEnter() {
    var img = document.getElementById('tqCatchImg');
    var frame = document.querySelector('.tq-reticle-frame');
    if (!img || !frame) return;
    img.classList.remove('tq-catch-img--swipe');
    function applyEnter() {
      var fr = frame.getBoundingClientRect();
      var ir = img.getBoundingClientRect();
      var dx = (fr.left + fr.width / 2) - (ir.left + ir.width / 2);
      var dy = (fr.top + fr.height / 2) - (ir.top + ir.height / 2);
      img.style.setProperty('--tq-catch-from-x', dx + 'px');
      img.style.setProperty('--tq-catch-from-y', dy + 'px');
      requestAnimationFrame(function () {
        img.classList.add('tq-catch-img--enter');
      });
    }
    img.classList.remove('tq-catch-img--enter');
    if (img.complete) {
      requestAnimationFrame(applyEnter);
    } else {
      img.onload = function () {
        img.onload = null;
        requestAnimationFrame(applyEnter);
      };
    }
  }

  /**
   * Confirm modal cover: placeholder swaps immediately (no stale art). Real URLs preload off-DOM so the
   * previous cover stays visible until the new file decodes (no empty beat).
   */
  function setCatchProductImage(url, opts) {
    opts = opts || {};
    var img = document.getElementById('tqCatchImg');
    if (!img) return;
    url = url || GENERIC_CART_SVG;
    if (!opts.instant) {
      img.src = url;
      return;
    }
    var isPlaceholder = url === GENERIC_CART_SVG;
    if (isPlaceholder) {
      setCatchProductImage._preloadTok = (setCatchProductImage._preloadTok || 0) + 1;
      img.onload = null;
      img.onerror = null;
      img.classList.remove('tq-catch-img--swap-pending', 'tq-catch-img--instant-reveal', 'tq-catch-img--swipe');
      img.classList.add('tq-catch-img--no-tx', 'tq-catch-img--enter');
      img.src = url;
      void img.offsetWidth;
      img.classList.remove('tq-catch-img--no-tx');
      return;
    }
    var cur = img.getAttribute('src') || '';
    if (cur === url) {
      img.classList.remove('tq-catch-img--swap-pending');
      if (!img.classList.contains('tq-catch-img--enter')) img.classList.add('tq-catch-img--enter');
      return;
    }
    var tok = (setCatchProductImage._preloadTok = (setCatchProductImage._preloadTok || 0) + 1);
    var pre = new Image();
    pre.onload = function () {
      if (tok !== setCatchProductImage._preloadTok) return;
      img.onload = null;
      img.onerror = null;
      img.classList.remove('tq-catch-img--swap-pending', 'tq-catch-img--instant-reveal', 'tq-catch-img--swipe');
      img.classList.add('tq-catch-img--no-tx', 'tq-catch-img--enter');
      img.src = url;
      requestAnimationFrame(function () {
        img.classList.remove('tq-catch-img--no-tx');
      });
    };
    pre.onerror = function () {
      if (tok !== setCatchProductImage._preloadTok) return;
      setCatchProductImage(GENERIC_CART_SVG, { instant: true });
    };
    pre.src = url;
  }

  function showCameraScanError(detail) {
    var el = document.getElementById('tqCameraScanError');
    var sub = el && el.querySelector('.tq-camera-scan-error-sub');
    var friendly = formatScanErrorForUser(detail);
    if (sub) {
      sub.textContent = friendly || 'Make sure the game cover is well-lit and in focus.';
    }
    if (el) el.hidden = false;
    if (showCameraScanError._t) clearTimeout(showCameraScanError._t);
    var dismissMs = friendly.length > 120 ? 6200 : 4000;
    showCameraScanError._t = setTimeout(function () {
      if (el) el.hidden = true;
    }, dismissMs);
  }

  function resetTqCatchAddButton() {
    var btn = document.getElementById('tqCatchAdd');
    if (!btn) return;
    btn.classList.remove('tq-catch-add-success');
    btn.textContent = 'Add to Quote';
  }

  var tqPageScrollLockDepth = 0;

  function lockPageScroll() {
    if (tqPageScrollLockDepth === 0) {
      catchBodyScrollLockY = window.scrollY || (document.documentElement && document.documentElement.scrollTop) || 0;
      document.documentElement.classList.add('tq-catch-scroll-lock');
      document.body.style.position = 'fixed';
      document.body.style.top = -catchBodyScrollLockY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }
    tqPageScrollLockDepth++;
  }

  function unlockPageScroll() {
    if (tqPageScrollLockDepth <= 0) return;
    tqPageScrollLockDepth--;
    if (tqPageScrollLockDepth > 0) return;
    document.documentElement.classList.remove('tq-catch-scroll-lock');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, catchBodyScrollLockY);
  }

  function releaseCatchModalViewportLock() {
    unlockPageScroll();
  }

  function populateCatchFromDraft() {
    if (!catchDraft) return;
    resetTqCatchAddButton();
    syncCatchConditionSegmentUI(catchDraft);
    var title = document.getElementById('tqCatchTitle');
    setCatchProductImage(catchDraft.imgUrl, { instant: true });
    if (title) {
      title.style.removeProperty('font-size');
      var fullTitle = catchDraft.title != null ? String(catchDraft.title).trim() : '';
      title.textContent = fullTitle;
      title.setAttribute('title', fullTitle);
    }
    syncCatchSystemPill();
    updateCatchPricesDisplay();
    syncCatchTradeEligibility();
  }

  function syncCatchTradeEligibility() {
    var addBtn = document.getElementById('tqCatchAdd');
    var skipBtn = document.getElementById('tqCatchSkip');
    var dismissBtn = document.getElementById('tqCatchDismiss');
    var rejectBox = document.getElementById('tqCatchRejectBox');
    var notAcceptingEl = document.getElementById('tqCatchNotAccepting');
    var offerWarn = document.getElementById('tqCatchOfferWarn');
    var badgesEl = document.getElementById('tqCatchMetaBadges');
    var hotlistNote = document.getElementById('tqCatchHotlistNote');
    var pricesEl = document.getElementById('tqCatchPrices');
    var segEl = document.getElementById('tqCatchSeg');
    var condHintEl = document.getElementById('tqCatchCondHint');
    var condContainerEl = document.getElementById('tqCatchCondContainer');
    var infoBanners = document.getElementById('tqCatchInfoBanners');
    var actionsEl = document.getElementById('tqCatchActions');
    if (!addBtn) return;
    if (!catchModalOpen || !catchReviewList.length || !catchDraft) {
      addBtn.classList.remove('tq-catch-add-success');
      addBtn.disabled = false;
      addBtn.hidden = false;
      addBtn.textContent = 'Add to Quote';
      if (skipBtn) {
        skipBtn.hidden = true;
        skipBtn.textContent = 'Skip';
        skipBtn.className = 'tq-btn tq-btn--secondary tq-catch-skip';
      }
      if (dismissBtn) {
        dismissBtn.hidden = false;
        dismissBtn.textContent = 'Skip';
        dismissBtn.className = 'tq-btn tq-btn--skip';
      }
      if (rejectBox) rejectBox.hidden = true;
      if (notAcceptingEl) {
        notAcceptingEl.hidden = true;
        notAcceptingEl.className = 'tq-catch-not-accepting';
      }
      if (offerWarn) offerWarn.hidden = true;
      if (hotlistNote) hotlistNote.hidden = true;
      if (badgesEl) {
        badgesEl.innerHTML = '';
        badgesEl.hidden = true;
      }
      if (pricesEl) pricesEl.hidden = false;
      if (segEl) segEl.hidden = false;
      if (condHintEl) condHintEl.hidden = false;
      if (condContainerEl) condContainerEl.hidden = false;
      if (infoBanners) infoBanners.hidden = false;
      if (actionsEl) {
        actionsEl.classList.remove('tq-catch-actions--restricted');
        actionsEl.classList.remove('tq-catch-actions--low-reject');
      }
      return;
    }
    var catalogBlocked = isStorefrontTradeCatalogBlocked(catchDraft);
    var low = isLowTradeGameScore(catchDraft);
    var scoreOrCatalogBlock = low || catalogBlocked;
    var noOffers = !scoreOrCatalogBlock && tradeOffersAllZero(catchDraft);
    var inPersonCashOnly = !scoreOrCatalogBlock && !noOffers && needsInPersonCashOffer(catchDraft);
    var restricted = scoreOrCatalogBlock || noOffers || inPersonCashOnly;
    if (rejectBox) rejectBox.hidden = true;
    if (notAcceptingEl) {
      notAcceptingEl.hidden = !restricted;
      notAcceptingEl.className = 'tq-catch-not-accepting';
      if (low || catalogBlocked) notAcceptingEl.classList.add('tq-catch-not-accepting--score');
      else if (inPersonCashOnly) notAcceptingEl.classList.add('tq-catch-not-accepting--inperson');
      var npt = notAcceptingEl.querySelector('.tq-catch-not-accepting-text');
      if (npt) {
        if (low || catalogBlocked) {
          npt.textContent = 'Unfortunately we are not accepting this game at this time.';
        } else if (inPersonCashOnly) {
          npt.textContent =
            "We can't quote cash for this title online. Bring it in store and we'll make an offer in person.";
        } else {
          npt.textContent =
            "We don't have usable trade pricing for this title online right now.";
        }
      }
    }
    if (offerWarn) offerWarn.hidden = true;
    if (pricesEl) pricesEl.hidden = restricted;
    if (segEl) segEl.hidden = restricted;
    if (condHintEl) condHintEl.hidden = restricted;
    if (condContainerEl) condContainerEl.hidden = restricted;
    if (infoBanners) infoBanners.hidden = restricted;
    if (hotlistNote) {
      hotlistNote.hidden = restricted || !itemIsHotlist(catchDraft);
    }
    if (badgesEl) {
      if (restricted) {
        badgesEl.innerHTML = '';
        badgesEl.hidden = true;
      } else {
        var parts = [];
        if (
          !scoreOrCatalogBlock &&
          catchDraft.gameScore != null &&
          catchDraft.gameScore !== '' &&
          !isNaN(Number(catchDraft.gameScore))
        ) {
          parts.push(
            '<span class="tq-game-score-pill">Score ' +
              escapeHtml(String(Math.round(Number(catchDraft.gameScore)))) +
              '</span>'
          );
        }
        if (parts.length) {
          badgesEl.innerHTML = parts.join(' ');
          badgesEl.hidden = false;
        } else {
          badgesEl.innerHTML = '';
          badgesEl.hidden = true;
        }
      }
    }
    addBtn.classList.remove('tq-catch-add-success');
    if (actionsEl) {
      actionsEl.classList.remove('tq-catch-actions--restricted');
      actionsEl.classList.remove('tq-catch-actions--low-reject');
    }
    if (scoreOrCatalogBlock || inPersonCashOnly) {
      if (actionsEl) actionsEl.classList.add('tq-catch-actions--low-reject');
      addBtn.hidden = true;
      addBtn.disabled = true;
      if (dismissBtn) {
        dismissBtn.hidden = false;
        dismissBtn.textContent = 'Skip';
        dismissBtn.className = 'tq-btn tq-btn--skip';
      }
      if (skipBtn) {
        skipBtn.hidden = true;
        skipBtn.textContent = 'Skip';
        skipBtn.className = 'tq-btn tq-btn--secondary tq-catch-skip';
      }
    } else {
      addBtn.disabled = noOffers;
      addBtn.hidden = noOffers;
      addBtn.textContent =
        !noOffers && catchDraft.scanDuplicateInCart ? 'Add another to Quote' : 'Add to Quote';
      if (dismissBtn) {
        dismissBtn.hidden = false;
        dismissBtn.textContent = 'Skip';
        dismissBtn.className = 'tq-btn tq-btn--skip';
      }
      if (skipBtn) {
        skipBtn.hidden = true;
        skipBtn.textContent = 'Skip';
        skipBtn.className = 'tq-btn tq-btn--secondary tq-catch-skip';
      }
      if (noOffers && actionsEl) actionsEl.classList.add('tq-catch-actions--restricted');
    }
  }

  function commitCatchDraftToList() {
    if (!catchDraft || catchReviewIndex < 0 || catchReviewIndex >= catchReviewList.length) return;
    catchReviewList[catchReviewIndex] = Object.assign({}, catchDraft);
  }

  /** Warm browser cache for prev/next queue covers (HTTP URLs only). */
  function preloadCatchAdjacentCoverUrls() {
    if (!catchModalOpen || catchReviewList.length < 2) return;
    function warm(item) {
      if (!item) return;
      var u = item.imgUrl;
      if (!u || typeof u !== 'string') return;
      if (u === GENERIC_CART_SVG || u.indexOf('data:') === 0) return;
      var im = new Image();
      im.decoding = 'async';
      im.src = u;
    }
    warm(catchReviewList[catchReviewIndex + 1]);
    warm(catchReviewList[catchReviewIndex - 1]);
  }

  /**
   * Game list cards use coverThumbUrlForSmallCard(imgUrl), not the raw modal URL — preload those
   * while the confirm flow is open so the sheet list hits HTTP cache after Add to Quote.
   */
  function preloadCatchQueueListThumbs() {
    if (!catchModalOpen || !catchReviewList.length) return;
    for (var i = 0; i < catchReviewList.length; i++) {
      var item = catchReviewList[i];
      if (!item) continue;
      var u = item.imgUrl;
      if (!u || typeof u !== 'string') continue;
      if (u === GENERIC_CART_SVG || u.indexOf('data:') === 0) continue;
      var thumb = coverThumbUrlForSmallCard(u);
      if (!thumb) continue;
      var im = new Image();
      im.decoding = 'async';
      im.src = thumb;
    }
  }

  function syncCameraStepBanner() {
    var el = root.querySelector('#tqCameraStepBanner');
    if (!el) return;
    /* Queue position is shown inside the catch card (#tqCatchPager). */
    el.hidden = true;
  }

  function updateCatchPager() {
    var el = document.getElementById('tqCatchPager');
    if (el) {
      if (catchModalOpen && catchBatchTotal > 1) {
        el.hidden = false;
        /* Position within original batch: accounts for removals (splice) and paging (catchReviewIndex). */
        var currentNum = catchBatchTotal - catchReviewList.length + catchReviewIndex + 1;
        if (currentNum < 1) currentNum = 1;
        if (currentNum > catchBatchTotal) currentNum = catchBatchTotal;
        el.textContent = 'Game ' + currentNum + ' of ' + catchBatchTotal;
        el.setAttribute('aria-label', 'Game ' + currentNum + ' of ' + catchBatchTotal);
      } else {
        el.hidden = true;
        el.textContent = '';
      }
    }
    syncCameraStepBanner();
  }

  /** Confirm modal: swap cover when paging multiple games — no swipe / scale animation (avoids jitter). */
  function runCatchCoverInstant() {
    var img = document.getElementById('tqCatchImg');
    if (!img) return;
    img.classList.remove('tq-catch-img--swipe');
    img.style.removeProperty('--tq-catch-from-x');
    img.style.removeProperty('--tq-catch-from-y');
    img.style.setProperty('transition', 'none');
    img.classList.add('tq-catch-img--enter');
    void img.offsetWidth;
    img.style.removeProperty('transition');
  }

  function applyCatchItemAtIndex(index, opts) {
    opts = opts || {};
    if (index < 0 || index >= catchReviewList.length) return;
    catchReviewIndex = index;
    resetCatchTitleEditUI();
    catchDraft = normalizeItem(Object.assign({}, catchReviewList[catchReviewIndex]));
    populateCatchFromDraft();
    if (opts.transition) {
      runCatchCoverInstant();
    } else {
      runCatchImgEnter();
    }
    updateCatchPager();
    preloadCatchAdjacentCoverUrls();
  }

  function openCatchModalAt(index, opts) {
    opts = opts || {};
    var c = document.getElementById('tqConfirmCatch');
    if (!c || !catchReviewList.length) return;
    if (index < 0 || index >= catchReviewList.length) return;
    catchReviewIndex = index;
    resetCatchTitleEditUI();
    catchModalOpen = true;
    scanPauseUntil = Infinity;
    setCameraCatchBlur(true);
    catchDraft = normalizeItem(Object.assign({}, catchReviewList[catchReviewIndex]));
    if (opts.initial) {
      c.hidden = false;
      root.classList.add('tq-catch-confirm-open');
      lockPageScroll();
    }
    populateCatchFromDraft();
    if (opts.initial) {
      requestAnimationFrame(function () {
        c.classList.add('tq-catch--open');
        runCatchCoverInstant();
      });
    } else {
      runCatchCoverInstant();
    }
    updateCatchPager();
    preloadCatchAdjacentCoverUrls();
    preloadCatchQueueListThumbs();
  }

  function openCatchModal(rawItem) {
    catchReviewList = [Object.assign({}, rawItem)];
    catchReviewIndex = 0;
    catchBatchTotal = 1;
    openCatchModalAt(0, { initial: true });
  }

  function finishCatchModal(resumeDelayMs) {
    resetCatchTitleEditUI();
    releaseCatchModalViewportLock();
    catchModalOpen = false;
    catchDraft = null;
    catchReviewList = [];
    catchBatchTotal = 0;
    catchReviewIndex = 0;
    setCameraCatchBlur(false);
    var imgEl = document.getElementById('tqCatchImg');
    if (imgEl) {
      imgEl.classList.remove('tq-catch-img--enter');
      imgEl.classList.remove('tq-catch-img--swipe');
    }
    var titleClr = document.getElementById('tqCatchTitle');
    if (titleClr) titleClr.style.removeProperty('font-size');
    var inpClr = document.getElementById('tqCatchTitleEdit');
    if (inpClr) inpClr.style.removeProperty('font-size');
    var addBtnReset = document.getElementById('tqCatchAdd');
    if (addBtnReset) {
      addBtnReset.classList.remove('tq-catch-add-success');
      addBtnReset.textContent = 'Add to Quote';
      addBtnReset.disabled = false;
      addBtnReset.hidden = false;
    }
    var skipReset = document.getElementById('tqCatchSkip');
    if (skipReset) {
      skipReset.hidden = true;
      skipReset.textContent = 'Skip';
      skipReset.className = 'tq-btn tq-btn--secondary tq-catch-skip';
    }
    var dismissReset = document.getElementById('tqCatchDismiss');
    if (dismissReset) {
      dismissReset.hidden = false;
      dismissReset.textContent = 'Skip';
      dismissReset.className = 'tq-btn tq-btn--skip';
    }
    var rejectReset = document.getElementById('tqCatchRejectBox');
    if (rejectReset) rejectReset.hidden = true;
    var notAcceptingReset = document.getElementById('tqCatchNotAccepting');
    if (notAcceptingReset) {
      notAcceptingReset.hidden = true;
      notAcceptingReset.className = 'tq-catch-not-accepting';
    }
    var offerReset = document.getElementById('tqCatchOfferWarn');
    if (offerReset) offerReset.hidden = true;
    var pricesReset = document.getElementById('tqCatchPrices');
    if (pricesReset) pricesReset.hidden = false;
    var segReset = document.getElementById('tqCatchSeg');
    if (segReset) segReset.hidden = false;
    var condHintReset = document.getElementById('tqCatchCondHint');
    if (condHintReset) condHintReset.hidden = false;
    var condContainerReset = document.getElementById('tqCatchCondContainer');
    if (condContainerReset) condContainerReset.hidden = false;
    var infoBannersReset = document.getElementById('tqCatchInfoBanners');
    if (infoBannersReset) infoBannersReset.hidden = false;
    var actionsReset = document.getElementById('tqCatchActions');
    if (actionsReset) {
      actionsReset.classList.remove('tq-catch-actions--restricted');
      actionsReset.classList.remove('tq-catch-actions--low-reject');
    }
    var badgesReset = document.getElementById('tqCatchMetaBadges');
    if (badgesReset) {
      badgesReset.innerHTML = '';
      badgesReset.hidden = true;
    }
    var hotReset = document.getElementById('tqCatchHotlistNote');
    if (hotReset) hotReset.hidden = true;
    var c = document.getElementById('tqConfirmCatch');
    if (c) {
      c.classList.remove('tq-catch--open');
      c.hidden = true;
    }
    root.classList.remove('tq-catch-confirm-open');
    var pPager = document.getElementById('tqCatchPager');
    if (pPager) {
      pPager.hidden = true;
      pPager.textContent = '';
    }
    scanPauseUntil = Date.now() + (resumeDelayMs || 0);
    syncCameraStepBanner();
    setCatchProductImage(GENERIC_CART_SVG, { instant: true });
  }

  /** Kill :active transform transition before catch layout swaps (avoids “pressed” anim on Skip after slide change). */
  function resetCatchActionBtnPressVisual(btn) {
    if (!btn) return;
    try {
      btn.blur();
    } catch (e) {}
    btn.style.setProperty('transition', 'none');
    btn.style.setProperty('transform', 'none');
    btn.style.removeProperty('box-shadow');
    void btn.offsetWidth;
    btn.style.removeProperty('transition');
    btn.style.removeProperty('transform');
  }

  function mountCatchModal() {
    var seg = document.getElementById('tqCatchSeg');
    if (seg && !seg.dataset.tqCatchMounted) {
      seg.dataset.tqCatchMounted = '1';
      seg.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-catch-cond]');
        if (!btn || !catchDraft) return;
        hapticLight();
        var cond = btn.getAttribute('data-catch-cond');
        var y = releaseYearFromItem(catchDraft);
        if (isModernCatalogYear(y) && cond === 'inbox') {
          cond = 'cib';
        }
        catchDraft.selected = cond;
        var modern = isModernCatalogYear(y);
        seg.querySelectorAll('[data-catch-cond]').forEach(function (b) {
          var k = b.getAttribute('data-catch-cond');
          if (modern && k === 'cib') return;
          var on = catchDraft.selected === k || (modern && k === 'inbox' && catchDraft.selected === 'cib');
          b.classList.toggle('is-selected', on);
        });
        updateCatchPricesDisplay();
        syncCatchTradeEligibility();
        commitCatchDraftToList();
      });
    }
    var addBtn = document.getElementById('tqCatchAdd');
    if (addBtn && !addBtn.dataset.tqCatchMounted) {
      addBtn.dataset.tqCatchMounted = '1';
      function addPressOn() {
        if (!addBtn.disabled) addBtn.classList.add('is-pressed');
      }
      function addPressOff() {
        addBtn.classList.remove('is-pressed');
      }
      addBtn.addEventListener('pointerdown', addPressOn);
      addBtn.addEventListener('pointerup', addPressOff);
      addBtn.addEventListener('pointerleave', addPressOff);
      addBtn.addEventListener('pointercancel', addPressOff);
      addBtn.addEventListener('click', function () {
        if (!catchDraft) return;
        if (isStorefrontTradeScoreOrCatalogBlocked(catchDraft)) return;
        if (tradeOffersAllZero(catchDraft)) return;
        if (needsInPersonCashOffer(catchDraft)) return;
        if (addBtn.classList.contains('tq-catch-add-success')) return;
        addBtn.textContent = 'Added! ✓';
        addBtn.classList.add('tq-catch-add-success');
        addBtn.disabled = true;
        setTimeout(function () {
          if (!catchModalOpen || !catchDraft) return;
          commitCatchTitleEdit();
          commitCatchDraftToList();
          var onBtn = document.querySelector('#tqCatchSeg .is-selected');
          var payload = Object.assign({}, catchDraft);
          delete payload.scanDuplicateInCart;
          payload.selected = (onBtn && onBtn.getAttribute('data-catch-cond')) || defaultConditionForSystem(payload.system);
          payload.isGoodCondition = !!catchDraft.isGoodCondition;
          catchReviewList.splice(catchReviewIndex, 1);
          addCartItems([payload], {
            vibrate: true,
            sheetSnap: 'peek',
          });
          if (!catchReviewList.length) {
            finishCatchModal(1000);
          } else {
            if (catchReviewIndex >= catchReviewList.length) {
              catchReviewIndex = catchReviewList.length - 1;
            }
            applyCatchItemAtIndex(catchReviewIndex, { transition: true });
          }
        }, 400);
      });
    }
    var editBtn = document.getElementById('tqCatchEdit');
    if (editBtn && !editBtn.dataset.tqCatchMounted) {
      editBtn.dataset.tqCatchMounted = '1';
      editBtn.addEventListener('click', function () {
        if (!catchDraft) return;
        hapticLight();
        var row = document.getElementById('tqCatchTitleRow');
        var h = document.getElementById('tqCatchTitle');
        var inp = document.getElementById('tqCatchTitleEdit');
        if (!h || !inp) return;
        if (!inp.hidden) {
          commitCatchTitleEdit();
          return;
        }
        catchTitleEditPrevSnap = state.sheetSnap;
        root.dataset.catchTitleEditing = 'true';
        if (state.sheetSnap !== 'peek') {
          state.sheetSnap = 'peek';
          root.dataset.sheetSnap = 'peek';
          applySheetTransform(false);
          syncSheetGrabberAria();
        }
        h.style.removeProperty('font-size');
        inp.style.removeProperty('font-size');
        if (row) row.classList.add('tq-catch-title-row--editing');
        editBtn.hidden = true;
        inp.value = catchDraft.title || '';
        h.hidden = true;
        inp.hidden = false;
        inp.focus();
        inp.select();
        var dd = document.getElementById('tqCatchTitleDropdown');
        if (dd && (inp.value || '').trim()) runCatchTitleSearch(inp, dd);
      });
    }
    var dismissCatch = document.getElementById('tqCatchDismiss');
    if (dismissCatch && !dismissCatch.dataset.tqCatchMounted) {
      dismissCatch.dataset.tqCatchMounted = '1';
      dismissCatch.addEventListener('click', function () {
        if (!catchModalOpen || !catchReviewList.length) return;
        resetCatchActionBtnPressVisual(dismissCatch);
        hapticLight();
        commitCatchTitleEdit();
        commitCatchDraftToList();
        catchReviewList.splice(catchReviewIndex, 1);
        if (!catchReviewList.length) {
          finishCatchModal(0);
        } else {
          if (catchReviewIndex >= catchReviewList.length) {
            catchReviewIndex = catchReviewList.length - 1;
          }
          applyCatchItemAtIndex(catchReviewIndex, { transition: true });
        }
      });
    }
    var titleEdit = document.getElementById('tqCatchTitleEdit');
    var titleDd = document.getElementById('tqCatchTitleDropdown');
    if (titleEdit && titleDd && !titleEdit.dataset.tqCatchMounted) {
      titleEdit.dataset.tqCatchMounted = '1';
      titleEdit.addEventListener('input', function () {
        if (titleEdit.hidden) return;
        if (catchSearchTimeout) clearTimeout(catchSearchTimeout);
        catchSearchTimeout = setTimeout(function () { runCatchTitleSearch(titleEdit, titleDd); }, 280);
      });
      titleEdit.addEventListener('blur', function () {
        if (!catchDraft) return;
        setTimeout(function () {
          if (!catchDraft) return;
          if (catchTitleBlurFromPick) {
            catchTitleBlurFromPick = false;
            return;
          }
          commitCatchTitleEdit();
        }, 0);
      });
      titleEdit.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          titleEdit.blur();
        }
      });
    }
  }

  function computeReticleVideoCrop(video) {
    var frame = document.querySelector('.tq-reticle-frame');
    if (!frame || !video.videoWidth) return null;
    var vw = video.videoWidth;
    var vh = video.videoHeight;
    var vr = video.getBoundingClientRect();
    if (vr.width < 2 || vr.height < 2) return null;
    var cr = frame.getBoundingClientRect();
    var scale = Math.max(vr.width / vw, vr.height / vh);
    var offsetX = (vr.width - vw * scale) / 2;
    var offsetY = (vr.height - vh * scale) / 2;
    var ix1 = Math.max(cr.left, vr.left);
    var iy1 = Math.max(cr.top, vr.top);
    var ix2 = Math.min(cr.right, vr.right);
    var iy2 = Math.min(cr.bottom, vr.bottom);
    if (ix2 <= ix1 + 1 || iy2 <= iy1 + 1) return null;
    var ex1 = ix1 - vr.left;
    var ey1 = iy1 - vr.top;
    var ex2 = ix2 - vr.left;
    var ey2 = iy2 - vr.top;
    var sx = (ex1 - offsetX) / scale;
    var sy = (ey1 - offsetY) / scale;
    var sw = (ex2 - ex1) / scale;
    var sh = (ey2 - ey1) / scale;
    sx = Math.max(0, Math.min(vw - 1, Math.round(sx)));
    sy = Math.max(0, Math.min(vh - 1, Math.round(sy)));
    sw = Math.max(1, Math.min(vw - sx, Math.round(sw)));
    sh = Math.max(1, Math.min(vh - sy, Math.round(sh)));
    return { sx: sx, sy: sy, sw: sw, sh: sh };
  }

  function clearCameraHostExceptFlash() {
    if (!els.cameraHost) return;
    [].slice.call(els.cameraHost.children).forEach(function (ch) {
      if (ch.id !== 'tqCameraFlash') ch.remove();
    });
  }

  async function stopCamera() {
    releaseCatchModalViewportLock();
    catchReviewList = [];
    catchBatchTotal = 0;
    catchReviewIndex = 0;
    catchModalOpen = false;
    catchDraft = null;
    var cCatch = document.getElementById('tqConfirmCatch');
    if (cCatch) {
      cCatch.classList.remove('tq-catch--open');
      cCatch.hidden = true;
    }
    root.classList.remove('tq-catch-confirm-open');
    var pPagerStop = document.getElementById('tqCatchPager');
    if (pPagerStop) {
      pPagerStop.hidden = true;
      pPagerStop.textContent = '';
    }
    scanPauseUntil = 0;
    captureScanInFlight = false;
    if (liveVideoStream) {
      liveVideoStream.getTracks().forEach(function (t) { t.stop(); });
      liveVideoStream = null;
    }
    setCameraCatchBlur(false);
    var cImgStop = document.getElementById('tqCatchImg');
    if (cImgStop) cImgStop.classList.remove('tq-catch-img--enter');
    clearCameraHostExceptFlash();
    var flashEl = document.getElementById('tqCameraFlash');
    if (flashEl) {
      flashEl.classList.remove('tq-camera-flash--on');
    }
  }

  function triggerCameraFlash() {
    var el = document.getElementById('tqCameraFlash');
    if (!el) return;
    el.classList.remove('tq-camera-flash--on');
    void el.offsetWidth;
    el.classList.add('tq-camera-flash--on');
    if (triggerCameraFlash._t) clearTimeout(triggerCameraFlash._t);
    triggerCameraFlash._t = setTimeout(function () {
      el.classList.remove('tq-camera-flash--on');
    }, 56);
  }

  async function ingestScanResultsToCatchModal(results) {
    if (!results || !results.length) {
      showToast('No games detected');
      return;
    }

    var usable = results.filter(function (g) {
      return !imageScanResultShouldSkipGenre(g);
    });
    if (!usable.length) {
      showToast('No games detected');
      return;
    }

    var cartPcids = new Set(state.cart.map(function (i) { return i.pcid; }).filter(Boolean));
    var seenBatch = new Set();
    var toAdd = [];

    usable.forEach(function (g) {
      var pid = g.pcid;
      if (pid && seenBatch.has(pid)) return;
      if (pid) seenBatch.add(pid);
      var copy = Object.assign({}, g);
      if (pid && cartPcids.has(pid)) {
        copy.scanDuplicateInCart = true;
      }
      toAdd.push(copy);
    });

    if (toAdd.length === 0) return;

    state.sheetSnap = 'peek';
    catchBatchTotal = toAdd.length;
    catchReviewList = toAdd.map(function (g) {
      return reshapeCatalogHitForCart(g);
    });
    catchReviewIndex = 0;
    if (!catchModalOpen) {
      openCatchModalAt(0, { initial: true });
    }
  }

  async function runCameraCaptureScan() {
    if (captureScanInFlight) return;
    if (catchModalOpen) return;
    if (Date.now() < scanPauseUntil) return;
    if (state.view !== 'camera') return;
    var video = els.cameraHost && els.cameraHost.querySelector('video');
    if (!video || !video.isConnected || !video.srcObject || video.readyState < 2) {
      showToast('Camera not ready');
      return;
    }

    var vw = video.videoWidth;
    var vh = video.videoHeight;
    if (vw < 2 || vh < 2) return;

    var crop = computeReticleVideoCrop(video);
    var sx;
    var sy;
    var sw;
    var sh;
    if (crop) {
      sx = crop.sx;
      sy = crop.sy;
      sw = crop.sw;
      sh = crop.sh;
    } else {
      sw = vw * 0.85;
      sh = vh * 0.55;
      sx = (vw - sw) / 2;
      sy = (vh - sh) / 2;
    }
    var maxOutW = 720;
    var outScale = Math.min(1, maxOutW / sw);
    var outW = Math.max(1, Math.round(sw * outScale));
    var outH = Math.max(1, Math.round(sh * outScale));

    if (!scanCanvas) scanCanvas = document.createElement('canvas');
    scanCanvas.width = outW;
    scanCanvas.height = outH;

    var ctx = scanCanvas.getContext('2d');
    ctx.drawImage(video, sx, sy, sw, sh, 0, 0, outW, outH);

    var scanErrOverlay = document.getElementById('tqCameraScanError');
    if (scanErrOverlay) scanErrOverlay.hidden = true;

    var capBtn = document.getElementById('tqCameraCapture');
    var galBtn = document.getElementById('tqBtnGalleryScan');
    captureScanInFlight = true;
    if (capBtn) capBtn.disabled = true;
    if (galBtn) galBtn.disabled = true;
    els.loader.hidden = false;
    els.loader.setAttribute('aria-hidden', 'false');
    setCatchProductImage._preloadTok = (setCatchProductImage._preloadTok || 0) + 1;
    setCatchProductImage(GENERIC_CART_SVG, { instant: true });
    try {
      var scanBlob = await new Promise(function (resolve, reject) {
        scanCanvas.toBlob(
          function (b) {
            if (!b) reject(new Error('Could not encode image.'));
            else resolve(b);
          },
          'image/jpeg',
          0.8
        );
      });
      var results = await performScanBlob(scanBlob);
      await ingestScanResultsToCatchModal(results);
    } catch (e) {
      var scanErr =
        e && e.message
          ? e.message
          : 'Make sure the game cover is well-lit and in focus.';
      showCameraScanError(scanErr);
    } finally {
      if (!(catchModalOpen && scanPauseUntil === Infinity)) {
        scanPauseUntil = Math.max(scanPauseUntil, Date.now() + 3000);
      }
      captureScanInFlight = false;
      if (capBtn) capBtn.disabled = false;
      if (galBtn) galBtn.disabled = false;
      els.loader.hidden = true;
      els.loader.setAttribute('aria-hidden', 'true');
    }
  }

  async function runGalleryPhotoScan(file) {
    if (!file) return;
    if (captureScanInFlight) return;
    if (catchModalOpen) return;
    if (Date.now() < scanPauseUntil) return;
    if (state.view !== 'camera') return;

    var scanErrOverlay = document.getElementById('tqCameraScanError');
    if (scanErrOverlay) scanErrOverlay.hidden = true;

    var capBtn = document.getElementById('tqCameraCapture');
    var galBtn = document.getElementById('tqBtnGalleryScan');
    captureScanInFlight = true;
    if (capBtn) capBtn.disabled = true;
    if (galBtn) galBtn.disabled = true;
    els.loader.hidden = false;
    els.loader.setAttribute('aria-hidden', 'false');
    setCatchProductImage._preloadTok = (setCatchProductImage._preloadTok || 0) + 1;
    setCatchProductImage(GENERIC_CART_SVG, { instant: true });
    try {
      var blob = await compressImage(file, 1080);
      var results = await performScanBlob(blob);
      await ingestScanResultsToCatchModal(results);
    } catch (e) {
      var scanErr =
        e && e.message
          ? e.message
          : 'Make sure the game cover is well-lit and in focus.';
      showCameraScanError(scanErr);
    } finally {
      if (!(catchModalOpen && scanPauseUntil === Infinity)) {
        scanPauseUntil = Math.max(scanPauseUntil, Date.now() + 3000);
      }
      captureScanInFlight = false;
      if (capBtn) capBtn.disabled = false;
      if (galBtn) galBtn.disabled = false;
      els.loader.hidden = true;
      els.loader.setAttribute('aria-hidden', 'true');
    }
  }

  async function startCamera() {
    await stopCamera();
    var view = els.cameraHost;
    if (!view) return;
    var video = document.createElement('video');
    video.setAttribute('autoplay', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('muted', '');
    video.style.cssText = 'width:100%;height:100%;object-fit:cover;';
    view.appendChild(video);
    try {
      var stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: 'environment',
          width: { ideal: 960, max: 1920 },
          height: { ideal: 540, max: 1080 },
        },
        audio: false,
      });
      liveVideoStream = stream;
      video.srcObject = stream;
      try {
        var playP = video.play();
        if (playP && typeof playP.catch === 'function') playP.catch(function () {});
      } catch (ePlay) {}
    } catch (err2) {
      clearCameraHostExceptFlash();
      var overlay = document.createElement('div');
      overlay.className = 'tq-camera-perm-overlay';
      overlay.setAttribute('role', 'alert');
      overlay.innerHTML =
        '<div class="tq-camera-perm-card">' +
        '<p class="tq-camera-perm-title">Camera Access Needed</p>' +
        '<p class="tq-camera-perm-text">We need your permission to scan games. You can also upload a photo from your gallery!</p>' +
        '<div class="tq-camera-perm-actions">' +
        '<button type="button" class="tq-btn tq-btn--primary tq-btn--block" id="tqCameraPermRetry">🔄 Try Again</button>' +
        '<button type="button" class="tq-btn tq-btn--secondary tq-btn--block" id="tqCameraPermGallery">🖼️ Upload from Gallery</button>' +
        '</div></div>';
      view.appendChild(overlay);
      var retryBtn = document.getElementById('tqCameraPermRetry');
      var permGalBtn = document.getElementById('tqCameraPermGallery');
      var galInput = document.getElementById('tqGalleryScanInput');
      if (retryBtn) {
        retryBtn.addEventListener('click', function () {
          hapticLight();
          void startCamera();
        });
      }
      if (permGalBtn && galInput) {
        permGalBtn.addEventListener('click', function () {
          hapticLight();
          galInput.click();
        });
      }
    }
  }

  function openCameraView() {
    withViewTransition(function () {
      releaseCatchModalViewportLock();
      var heroPanelGo = document.getElementById('tqHeroSearchPanel');
      var heroTogGo = document.getElementById('tqHeroSearchToggle');
      var heroInpGo = document.getElementById('tqSearchHero');
      var heroDdGo = document.getElementById('tqSearchDropdownHero');
      if (heroPanelGo) heroPanelGo.hidden = true;
      if (heroTogGo) heroTogGo.setAttribute('aria-expanded', 'false');
      delete root.dataset.heroQuoteOpen;
      root.dataset.tqPeekManualSearch = 'false';
      if (heroInpGo) heroInpGo.value = '';
      if (heroDdGo) {
        heroDdGo.hidden = true;
        heroDdGo.innerHTML = '';
      }
      catchReviewList = [];
      catchBatchTotal = 0;
      catchReviewIndex = 0;
      catchModalOpen = false;
      catchDraft = null;
      var cCatch = document.getElementById('tqConfirmCatch');
      if (cCatch) {
        cCatch.classList.remove('tq-catch--open');
        cCatch.hidden = true;
      }
      root.classList.remove('tq-catch-confirm-open');
      var pPagerOpen = document.getElementById('tqCatchPager');
      if (pPagerOpen) {
        pPagerOpen.hidden = true;
        pPagerOpen.textContent = '';
      }
      var cImg = document.getElementById('tqCatchImg');
      if (cImg) cImg.classList.remove('tq-catch-img--enter');
      scanPauseUntil = 0;
      var camErrEl = document.getElementById('tqCameraScanError');
      if (camErrEl) camErrEl.hidden = true;
      var camSnap = 'peek';
      if (state.cart.length > 0 && (state.sheetSnap === 'full' || state.sheetSnap === 'expanded')) {
        camSnap = state.sheetSnap;
      }
      setState({ view: 'camera', sheetSnap: camSnap });
      render();
      void startCamera();
    });
  }

  function findFixedContainingBlock(el) {
    for (var n = el && el.parentElement; n; n = n.parentElement) {
      var st = window.getComputedStyle(n);
      if (st.transform && st.transform !== 'none') return n;
      if (st.filter && st.filter !== 'none') return n;
      var p = st.perspective;
      if (p && p !== 'none' && p !== '0px') return n;
    }
    return null;
  }

  function positionSearchDropdown(inputEl, ddEl) {
    if (!inputEl || !ddEl || ddEl.hidden) return;
    var r = inputEl.getBoundingClientRect();
    var block = findFixedContainingBlock(ddEl);
    if (block) {
      var br = block.getBoundingClientRect();
      ddEl.style.top = (r.bottom - br.top + 6) + 'px';
      ddEl.style.left = (r.left - br.left) + 'px';
    } else {
      ddEl.style.top = (r.bottom + 6) + 'px';
      ddEl.style.left = r.left + 'px';
    }
    ddEl.style.width = r.width + 'px';
  }

  function runManualSearch(inputEl, ddEl) {
    var q = normalizeSearchQueryForApi((inputEl.value || '').trim());
    if (!q) {
      ddEl.hidden = true;
      ddEl.innerHTML = '';
      return;
    }
    ddEl.hidden = false;
    positionSearchDropdown(inputEl, ddEl);
    ddEl.innerHTML = '<div class="tq-dd-load">Searching…</div>';
    positionSearchDropdown(inputEl, ddEl);
    fetch(TRADE_CALC_SEARCH_URL + '?q=' + encodeURIComponent(q))
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var results = (data && data.results) ? data.results : [];
        manualSearchLastResults = results;
        if (!results.length) {
          ddEl.innerHTML = '<div class="tq-dd-empty">No matches. Try another name or system.</div>';
          positionSearchDropdown(inputEl, ddEl);
          return;
        }
        ddEl.innerHTML = results
          .map(function (item, idx) {
            return searchDdRowHtml(item, idx, { forCartAdd: true });
          })
          .join('');
        positionSearchDropdown(inputEl, ddEl);
        ddEl.querySelectorAll('[data-idx]').forEach(function (btn) {
          btn.addEventListener('mousedown', function (e) { e.preventDefault(); });
          btn.addEventListener('click', function () {
            var item = manualSearchLastResults[parseInt(btn.getAttribute('data-idx'), 10)];
            if (!item) return;
            var norm = reshapeCatalogHitForCart(item);
            if (tradeSearchBlockReason(norm)) return;
            inputEl.value = '';
            ddEl.hidden = true;
            var addOpts = {
              flyImg: true,
              blurSheetSearch: inputEl.id === 'tqSearch',
              scrollQuoteListToTop: true,
            };
            if (inputEl.id === 'tqSearch' && (state.view === 'camera' || state.view === 'hero')) {
              addOpts.sheetSnap = 'full';
            }
            addCartItems([norm], addOpts);
          });
        });
      })
      .catch(function () {
        ddEl.innerHTML = '<div class="tq-dd-empty">Search failed.</div>';
        positionSearchDropdown(inputEl, ddEl);
      });
  }

  function hideAllSearchDropdowns() {
    [els.searchDd, document.getElementById('tqSearchDropdownHero'), document.getElementById('tqCatchTitleDropdown')].forEach(function (el) {
      if (el) el.hidden = true;
    });
  }

  /** Hero + empty quote: hide the sheet after Search Manually if nothing was added (no bottom bar). */
  function dismissHeroSheetIfNoQuote() {
    if (state.view !== 'hero' || state.cart.length > 0) return;
    if (root.dataset.heroQuoteOpen !== 'true') return;
    delete root.dataset.heroQuoteOpen;
    root.dataset.tqPeekManualSearch = 'false';
    var ht = document.getElementById('tqHeroSearchToggle');
    if (ht) ht.setAttribute('aria-expanded', 'false');
    if (els.search) els.search.value = '';
    if (els.searchDd) {
      els.searchDd.hidden = true;
      els.searchDd.innerHTML = '';
    }
    state.sheetSnap = 'peek';
    render();
  }

  function bindSearchInput(inputEl, ddEl) {
    if (!inputEl || !ddEl) return;
    function expandSheetForPeekSearch() {
      if (inputEl.id !== 'tqSearch') return;
      if (state.sheetSnap === 'full' || state.sheetSnap === 'expanded') return;
      root.dataset.tqPeekManualSearch = 'true';
      setState({ sheetSnap: 'expanded' });
      requestAnimationFrame(function () {
        scheduleNudgeManualSearchViewport();
        if (!ddEl.hidden) positionSearchDropdown(inputEl, ddEl);
      });
    }
    inputEl.addEventListener('input', function () {
      expandSheetForPeekSearch();
      if (inputEl.id === 'tqSearch') syncPeekAddMoreVisibility();
      if (manualSearchTimeout) clearTimeout(manualSearchTimeout);
      manualSearchTimeout = setTimeout(function () { runManualSearch(inputEl, ddEl); }, 280);
    });
    inputEl.addEventListener('focus', function () {
      expandSheetForPeekSearch();
      if (inputEl.id === 'tqSearch') syncPeekAddMoreVisibility();
      /* Camera: nudge runs from sheet focusin — avoid double schedule (jitter with keyboard). */
      if ((inputEl.value || '').trim()) runManualSearch(inputEl, ddEl);
      else if (!ddEl.hidden) {
        requestAnimationFrame(function () { positionSearchDropdown(inputEl, ddEl); });
      }
    });
    if (inputEl.id === 'tqSearch') {
      inputEl.addEventListener('blur', function () {
        setTimeout(function () {
          var ae = document.activeElement;
          if (ae && ae.closest && ae.closest('.tq-dropdown')) return;
          if (ae && els.sheet && ae.closest && ae.closest('#tqSheet') && els.sheet.contains(ae)) return;
          root.dataset.tqPeekManualSearch = 'false';
          dismissHeroSheetIfNoQuote();
          syncPeekAddMoreVisibility();
          applySheetTransform(false);
        }, 80);
      });
    }
  }

  var btnLive = document.getElementById('tqBtnLive');
  if (btnLive) {
    btnLive.addEventListener('click', function () {
      resetTradeQuote();
      openCameraView();
    });
  } else {
    console.error('[tq] #tqBtnLive not found');
  }
  (function () {
    function onAddMoreFromSheet() {
      hapticLight();
      setState({ sheetSnap: 'peek' });
      openCameraView();
    }
    var takePicturesPeek = document.getElementById('tqBtnPeekTakePictures');
    var peekAddMoreCam = document.getElementById('tqBtnPeekAddMoreCamera');
    if (takePicturesPeek) takePicturesPeek.addEventListener('click', onAddMoreFromSheet);
    if (peekAddMoreCam) {
      peekAddMoreCam.addEventListener('click', function () {
        hapticLight();
        setState({ sheetSnap: 'peek' });
      });
    }
  })();
  (function () {
    var galIn = document.getElementById('tqGalleryScanInput');
    var galBtn = document.getElementById('tqBtnGalleryScan');
    if (galBtn && galIn) {
      galBtn.addEventListener('click', function () {
        if (captureScanInFlight) return;
        galIn.click();
      });
      galIn.addEventListener('change', function (e) {
        var f = e.target.files && e.target.files[0];
        e.target.value = '';
        if (!f) return;
        runGalleryPhotoScan(f);
      });
    }
  })();

  var failOk = document.getElementById('tqFailOk');
  if (failOk) {
    failOk.addEventListener('click', function () {
      if (els.fail) els.fail.hidden = true;
    });
  }

  bindSearchInput(els.search, els.searchDd);
  bindImportUi();

  (function () {
    var toggle = document.getElementById('tqHeroSearchToggle');
    var panel = document.getElementById('tqHeroSearchPanel');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', function () {
      var opening = toggle.getAttribute('aria-expanded') !== 'true';
      if (opening) {
        clearTradeQuoteData();
        panel.hidden = true;
        root.dataset.heroQuoteOpen = 'true';
        root.dataset.tqPeekManualSearch = 'true';
        setState({ sheetSnap: 'expanded' });
        toggle.setAttribute('aria-expanded', 'true');
        animateTotalsTo(0, 0);
        requestAnimationFrame(function () {
          scrollTradeQuoteListToTop();
        });
        if (els.search) {
          setTimeout(function () {
            try {
              els.search.focus({ preventScroll: true });
            } catch (e) {
              els.search.focus();
            }
            applySheetTransform(false);
          }, 30);
        }
        return;
      }
      toggle.setAttribute('aria-expanded', 'false');
      root.dataset.tqPeekManualSearch = 'false';
      if (els.searchDd) {
        els.searchDd.hidden = true;
        els.searchDd.innerHTML = '';
      }
      if (els.search) els.search.value = '';
      if (state.cart.length) setState({ sheetSnap: 'peek' });
      else delete root.dataset.heroQuoteOpen;
      render();
      applySheetTransform(false);
    });
  })();

  if (els.sheetListWrap) {
    els.sheetListWrap.addEventListener('scroll', function () {
      if (els.searchDd && !els.searchDd.hidden) els.searchDd.hidden = true;
      var hDd = document.getElementById('tqSearchDropdownHero');
      if (hDd && !hDd.hidden) hDd.hidden = true;
      var cdd = document.getElementById('tqCatchTitleDropdown');
      if (cdd && !cdd.hidden) cdd.hidden = true;
    }, { passive: true });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.tq-input-wrap') && !e.target.closest('.tq-dropdown')) hideAllSearchDropdowns();
    var t = e.target;
    if (
      state.view === 'hero' &&
      !state.cart.length &&
      root.dataset.heroQuoteOpen === 'true' &&
      t.closest &&
      !t.closest('#tqSheet') &&
      !t.closest('#tqHeroSearchToggle')
    ) {
      dismissHeroSheetIfNoQuote();
    }
  });

  if (els.sysFilter) {
    els.sysFilter.addEventListener('change', function () {
      state.systemFilter = els.sysFilter.value;
      render();
    });
  }

  (function () {
    var cap = document.getElementById('tqCameraCapture');
    if (cap) {
      function pressOn() {
        if (!cap.disabled) cap.classList.add('is-pressed');
      }
      function pressOff() {
        cap.classList.remove('is-pressed');
      }
      cap.addEventListener('pointerdown', pressOn);
      cap.addEventListener('pointerup', pressOff);
      cap.addEventListener('pointerleave', pressOff);
      cap.addEventListener('pointercancel', pressOff);
      cap.addEventListener('click', function () {
        haptic();
        triggerCameraFlash();
        void runCameraCaptureScan();
      });
    }
  })();

  (function () {
    var host = els.cameraHost;
    if (!host || host.dataset.tqTapCaptureMounted) return;
    host.dataset.tqTapCaptureMounted = '1';
    host.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.tq-camera-perm-overlay')) return;
      if (e.target.closest && e.target.closest('#tqBtnGalleryScan')) return;
      if (e.target.closest && e.target.closest('#tqCameraCapture')) return;
      if (state.view !== 'camera') return;
      if (captureScanInFlight) return;
      if (catchModalOpen) return;
      if (Date.now() < scanPauseUntil) return;
      haptic();
      triggerCameraFlash();
      void runCameraCaptureScan();
    });
  })();

  var clearAllBtn = document.getElementById('tqClearAll');
  if (clearAllBtn) {
    clearAllBtn.addEventListener('click', function () {
      if (!state.cart.length) return;
      if (!confirm('Clear all games from this quote?')) return;
      void stopCamera();
      clearTradeQuoteData();
      setState({ view: 'hero' });
      animateTotalsTo(0, 0);
    });
  }
  (function () {
    var resumeL = document.getElementById('tqHeroResumeLink');
    if (!resumeL) return;
    resumeL.addEventListener('click', function () {
      if (!state.cart.length) return;
      hapticLight();
      root.dataset.heroQuoteOpen = 'true';
      state.sheetSnap = 'full';
      render();
      requestAnimationFrame(function () {
        scrollTradeQuoteListToTop();
      });
    });
  })();
  function triggerFinalizeQuote() {
    if (!state.cart.length) return;
    haptic();
    var flashEl = document.getElementById('tqCameraFlash');
    if (flashEl) {
      flashEl.classList.remove('tq-camera-flash--on');
      flashEl.style.opacity = '0';
    }
    if (triggerCameraFlash._t) clearTimeout(triggerCameraFlash._t);
    if (state.mailAddressSnapshot) {
      setState({
        checkoutStep: 'mail',
        tradeType: 'mail',
        mailSubmitResult: null,
        mailSubmitPending: false,
      });
    } else {
      setState({
        checkoutStep: 'pick',
        tradeType: null,
        mailFlowStep: 'quality',
        mailSubmitResult: null,
        mailSubmitPending: false,
        mailAddressSnapshot: null,
        mailPaymentMethod: 'paypal',
        mailPaymentDetail: '',
        mailQualityAcknowledged: false,
      });
    }
    render();
  }
  var finalizeBtn = document.getElementById('tqFinalize');
  if (finalizeBtn) finalizeBtn.addEventListener('click', triggerFinalizeQuote);
  (function () {
    var peekR = document.getElementById('tqPeekReviewList');
    if (peekR) {
      peekR.addEventListener('click', function () {
        hapticLight();
        setState({ sheetSnap: 'full' });
        render();
        requestAnimationFrame(function () {
          scrollTradeQuoteListToTop();
        });
      });
    }
  })();
  var checkoutCloseBtn = document.getElementById('tqCheckoutClose');
  if (checkoutCloseBtn) {
    checkoutCloseBtn.addEventListener('click', function () {
      if (isMailSuccessCheckout()) {
        void stopCamera();
        clearTradeQuoteData();
        setState({
          view: 'hero',
          checkoutStep: null,
          tradeType: null,
          mailFlowStep: 'quality',
          mailSubmitResult: null,
          mailSubmitPending: false,
          mailAddressSnapshot: null,
          mailPaymentMethod: 'paypal',
          mailPaymentDetail: '',
          mailQualityAcknowledged: false,
        });
        render();
        animateTotalsTo(0, 0);
        return;
      }
      setState({
        checkoutStep: null,
        tradeType: null,
        mailFlowStep: 'quality',
        mailSubmitResult: null,
        mailSubmitPending: false,
        mailAddressSnapshot: null,
        mailPaymentMethod: 'paypal',
        mailPaymentDetail: '',
        mailQualityAcknowledged: false,
      });
      render();
    });
  }
  if (els.checkout) {
    els.checkout.addEventListener('click', function (e) {
      if (e.target === els.checkout) {
        setState({
          checkoutStep: null,
          tradeType: null,
          mailFlowStep: 'quality',
          mailSubmitResult: null,
          mailSubmitPending: false,
          mailAddressSnapshot: null,
          mailPaymentMethod: 'paypal',
          mailPaymentDetail: '',
          mailQualityAcknowledged: false,
        });
        render();
      }
    });
  }

  window.addEventListener('resize', onSheetViewportResize);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') resumeLiveCameraPreview();
  });
  window.addEventListener('pagehide', function () {
    void stopCamera();
  });

  loadQuoteIdFromStorage();
  loadCartFromStorage();
  if (inStoreCartLinesForApi().length) {
    setTimeout(function () {
      doStorefrontQuoteSync();
    }, 400);
  }
  if (state.cart.length) {
    updateSystemFilterOptions();
    var tLoaded = cartTotals();
    displayedTotals = { credit: tLoaded.credit, cash: tLoaded.cash };
    if (els.peekCredit) els.peekCredit.textContent = formatMoneyPlain(displayedTotals.credit);
    if (els.peekCash) els.peekCash.textContent = formatMoneyPlain(displayedTotals.cash);
  } else {
    root.dataset.hasCart = 'false';
  }

  mountSheetToggle();
  mountSheetPeekSwipe();
  mountSheetKeyboardFix();
  mountCheckoutBodyDelegation();
  mountListReviewDensityObserver();
  mountCatchModal();
  applySheetTransform();
  render();
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      syncAllListReviewCardDensities();
    });
  }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tqRunInit);
  } else {
    tqRunInit();
  }
})();
